<template>
  <div class="test-view may-18-test" :class="isPreview && isTestCustom ? 'show-all-mobile': ''">
    <div v-if="isOnline" >
      <div :class="isPreview && isTestCustom && isOnlineTest ? 'test-page-section new-cp-5dec' : !isOnlineTest || !isTestCustom ? 'test-page-section new-cp-5dec-mobile' : 'test-page-section ' " ref="testView">
        <div class="test-btn-quection">
          <div class="test-info-block">
            <div class="ts-info order-ts-1">
              <span>Paper Coverage</span>
                  <v-icon
                    class="info-alert"
                    @click="onPaperCoverage"
                    >mdi-alert-circle</v-icon
                  >             
            </div>
            <div class="vertical-line"></div>
            <div class="ts-info order-ts-2">
              <span>Question Paper</span>
              <v-icon class="info-alert" v-if="innerWidth<991" @click="showAllQuestions"
                >mdi-information</v-icon
              >
              <v-tooltip v-else bottom content-class="question-tooltip">
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" class="info-alert" @click="showAllQuestions"
                >mdi-information</v-icon>
                </template>
                <div class="tool-data-row">Click here to see all questions in the test</div>
              </v-tooltip>
            </div>
          </div>
          <div :class="isPreview && isTestCustom && isOnlineTest ? 'slide-btn-group cust-slide cp3-5dec' : !isOnlineTest || !isTestCustom ? 'slide-btn-group cust-slide cp3-5dec-mobile' : 'slide-btn-group cust-slide ' ">
            <v-row>
              <v-col cols="1" sm="1" class="pad-zero-top-bottom">
                <div
                  v-if="
                    $refs && $refs.carousel && $refs.carousel.canAdvanceBackward
                  "
                  class="center-arrow1"
                >
                  <v-icon
                    @click.prevent="gotoDirection(true, 'backward')"
                    class="info-alert"
                    >mdi-chevron-double-left</v-icon
                  >
                  <v-icon
                    @click.prevent="gotoDirection(false, 'backward')"
                    class="info-alert"
                    >mdi-chevron-left</v-icon
                  >
                </div>
              </v-col>
              <v-col cols="10" sm="10" class="pad-zero-top-bottom">
                <carousel
                  ref="carousel"
                  :navigateTo="navigateTo"
                  :scrollPerPage="scrollPerPage"
                  :paginationEnabled="false"
                  :mouseDrag="false"
                  :perPageCustom="perPageCustom"
                >
                  <slide
                    v-for="(type, idx) in subjectQuestionTypeList"
                    :key="idx"
                    v-if="type.showSQT"
                  >
                    <v-btn
                      class="btn-default carousel-btn"
                      :class="{
                        ' active ': idx == selectedSQTIndex,
                        'disabled-field': disableSecondaryAction,
                      }"
                      depressed
                      width="95%"
                      :disabled="isEditing || disableSecondaryAction"
                      :title="type.name"
                      @click="changeSubjectQuestionType(type, idx, 'JUMP')"
                    >
                      <span class="carousel-typename">{{
                        type.shortName
                      }}</span>
                      <v-tooltip bottom dark content-class="question-tooltip">
                        <template v-slot:activator="{ on }">
                          <v-icon
                            class="info-alert"
                            v-on="on"
                            @mouseover="getLegendsData(idx)"
                            >mdi-information</v-icon
                          >
                        </template>
                        <LegendsOnHover
                          :legendsCount="legendsData"
                          :isPreview="isPreview"
                        />
                      </v-tooltip>
                    </v-btn>
                  </slide>
                </carousel>
              </v-col>
              <v-col cols="1" sm="1" class="pad-zero-top-bottom">
                <div
                  v-if="
                    $refs && $refs.carousel && $refs.carousel.canAdvanceForward
                  "
                  class="center-arrow2"
                >
                  <v-icon
                    @click.prevent="gotoDirection(false, 'forward')"
                    class="info-alert"
                    >mdi-chevron-right</v-icon
                  >
                  <v-icon
                    @click.prevent="gotoDirection(true, 'forward')"
                    class="info-alert"
                    >mdi-chevron-double-right</v-icon
                  >
                </div>
              </v-col>
            </v-row>
          </div>
          <div class="test-counter-block test-couter-cp3 show-mobile-panel">
           <div class="test-time-count">
                    <div class="time-remaining-title">
                      <v-btn
                v-if="isPreview && isTestCustom"
                @click="similarQuestionsPopup"
                class="question-bucket right-align "
                :class="{
                  active:
                    !isSearchAnotherQ &&
                    !isUploadAndReplace &&
                    currentQuestion.institute_id === null && isEditableTest
                }"
                ><div>
                  <div class="Bucket-que">Show All</div>
                  <div class="Bucket-select">
                    Questions of Same Topic
                  </div>
                </div></v-btn
              >
                    </div>
                    <div class="time-remaining-count">
                      &nbsp;
                    </div>
                  </div>
                  </div>
          <v-expansion-panels
            class="show-mobile-panel"
            :disabled="disableSecondaryAction"
            v-model="expansionPanelStatus"
          >
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div class="expansion-title mini-question-palette">
                  Question Palette
                  <MiniQuestionPallet
                    v-if="questionData"
                    :isPastTest="isPastTest"
					:isPreview="isPreview"
                    :questionData="questionData"
                  />
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div class="test-counter-block test-couter-cp3">
                  <div class="inner-block">
                    <div class="number-contet">
                      <LegendsPreview
                        v-if="questionData"
                        :questionStatus="questionStatus"
						:isPreview="isPreview"
                        :questions="questionData.questions"
                      />
                      <div class="hr-div"></div>
                      <QuestionPallet
                        v-if="questionData"
                        @jumpToQuestion="jumpToQuestion"
                        :isEditing="isEditing"
						:isPreview="isPreview"
                        :isPastTest="isPastTest"
						:isCustom="isTestCustom"
                        :questionData="questionData"
                      />
                    </div>
                    <div class="test-foter-blk">
                      <div
                        class="test-btn-block-ans smallFont"
                      >
                      <div class="marking marking-bold" >
									{{questionData && questionData.mandatoryQuestions && (questionData.mandatoryQuestions.allow_all ===1 || questionData.mandatoryQuestions.allow_all ===0) ? `Out of the ${questionData.questions.length} Questions ${questionData.mandatoryQuestions.mandatory_questions} are Mandatory`: "All Questions in this section are Mandatory"}}
								
								</div>
								<div class="marking">
									{{questionData && questionData.mandatoryQuestions ? questionData.mandatoryQuestions.allow_all ===1 ? `You can answer all questions but the best  ${questionData.mandatoryQuestions.mandatory_questions} shall be evaluated`:
                  `You can only answer the mandatory number of questions`: ""}}
								</div>
                        <div class="marking marking-bold">
                          Marking Scheme for this section:
                        </div>
                        <div class="marking">
                          Correct Response:+
                          {{ currentQuestion.correct_marks }}
                        </div>
                        <div class="marking">
                          Incorrect Response:{{
                            currentQuestion.negative_marks
                          }}
                        </div>
                        <div
                          class="marking"
                          v-if="
                            isPreview && currentQuestion.partial_marking > 0
                          "
                        >
                          <v-icon small color="success"
                            >mdi-checkbox-marked</v-icon
                          >
                          Partial Marking:{{ currentQuestion.partial_marking }}
                        </div>
                        <div
                          v-if="
                            isPreview && currentQuestion.partial_marking == 0
                          "
                          class="marking markingElse"
                        >
                          <v-icon small color="success"
                            >mdi-checkbox-marked</v-icon
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          <v-card class="mx-auto normal-card live-test-hg" ref="testBlock">
            <pinch-zoom
              class="pinch-zoom"
              disableZoomControl="disable"
              :wheel="false"
            >
              <div class="tst-quection-block directorpriviewtest click-upload-replace-outer" 
 ref="questionBox">
                <div v-if="questionData && questionTypes">
                  <div v-if="isEditing || isUploadAndReplace" :class="{'without-upload-&-replace-height-control' : !isUploadAndReplace, 'with-upload-&-replace-height-control' : isUploadAndReplace }">
                    <div>
                    <div class="chapter-name-row click-upload-replace">
                    <div class="cha-Upload-row ">
                      <div class="chapter-label cha-Upload-label-1 ">
                        Chapter Name
                        <span>*</span>
                      </div>
                      <div class="chapter-drop">
                        <v-select
                          v-model="slectedChapter"
                          @change="onSelectChapter"
                          :items="chapters"
                          hide-details
                          dense
                          outlined
                          ref="chapterName"
                          class="dropdown-fix-160"
                        ></v-select>
                      </div>

                      <div
                        class="chapter-label cha-Upload-label-1"
						v-if="isDBTest"
                      >
                        Topic Name
                        <span>*</span>
                      </div>
                      <div
						v-if="isDBTest"
                        class="chapter-drop"
                      >
                        <v-select
                          v-model="selectedTopic"
                          @change="onSelectedTopic"
                          :items="topics"
                          hide-details
                          dense
                          outlined
                          ref="chapterName"
                          class="dropdown-fix-160"
                        ></v-select>
                      </div>
                    
                      <div
						v-if="isDBTest"
                        class="chapter-label cha-Upload-label-1"
                      >
                        Level
                        <span>*</span>
                      </div>
                      <div
						v-if="isDBTest"
                        class="chapter-drop"
                      >
                        <v-select
                          v-model="selectedDifficultyLevel"
                          @change="onselectedDifficulty"
                          :items="difficulty"
                          hide-details
                          dense
                          outlined
                          ref="chapterName"
                          class="dropdown-fix-160"
                        ></v-select>
                      </div>
                    </div>
                    <div class="cha-Upload-row" v-if="isDBTest">
                      <div class="chapter-label cha-Upload-label-1">
                        SubTopic
                        <span>*</span>
                      </div>
                      <div class="chapter-drop">
                        <v-select
                          v-model="selectedSubTopic"
                          @change="onSelectedSubTopic"
                          :items="subTopics"
                          hide-details
                          dense
                          outlined
                          ref="chapterName"
                          class="dropdown-fix-160"
                        ></v-select>
                      </div>

                      <div
                        class="chapter-label cha-Upload-label-1"
                        
                      >
                        Concept
                        <span>*</span>
                      </div>
                      <div
                        class="chapter-drop"
                      >
                        <v-select
                          v-model="selectedConcept"
                          @change="onSelectedConcept"
                          :items="concepts"
                          hide-details
                          dense
                          outlined
                          ref="chapterName"
                          class="dropdown-fix-160"
                        ></v-select>
                      </div>

                      <div
                        class="chapter-label cha-Upload-label-1"
                      >
                        Skillset
                        <span>*</span>
                      </div>
                      <div
                        class="chapter-drop"
                      >
                        <v-select
                          v-model="selectedSkillSet"
                          :items="skillset"
						  @change="onselectedSkillset"
                          hide-details
                          dense
                          outlined
                          ref="chapterName"
                          class="dropdown-fix-160"
                        ></v-select>
                      </div>
                    </div>
                    </div>
                  </div>
                  <div class="upload-replace-scrooalble">
                    <SingleAnsQue
                      :showNextButton="showNextButton"
                      :question="currentQuestionToBeEdited"
                      :isEditable="isEditable"
                      v-if="
                        currentQuestion.question_type ==
                          questionTypes.SINGLE_CORRECT ||
	   				    currentQuestion.question_type ==
                           questionTypes.SINGLE_CORRECT_SEC2 ||
                          currentQuestion.question_type ==
                            questionTypes.ASSERTION_REASON
                      "
                    />

                    <MultipleCorrect
                      :showNextButton="showNextButton"
                      :question="currentQuestionToBeEdited"
                      :isEditable="isEditable"
                      v-if="
                        currentQuestion.question_type ==
                          questionTypes.MULTIPLE_CORRECT
                      "
                    />
                    <Integer
                      :showNextButton="showNextButton"
                      :isEditable="isEditable"
                      :question="currentQuestionToBeEdited"
                      v-if="
                        currentQuestion.question_type == questionTypes.INTEGER
                      "
                    />
                    <Subjective
                      :showNextButton="showNextButton"
                      :isEditable="isEditable"
                      :question="currentQuestionToBeEdited"
                      v-if="
                        currentQuestion.question_type ==
                          questionTypes.SUBJECTIVE ||
                          currentQuestion.question_type ==
                          questionTypes.SUBJECTIVEINTEGER
                      "
                    />
                    <MatrixMatch
                      :showNextButton="showNextButton"
                      :isEditable="isEditable"
                      :question="currentQuestionToBeEdited"
                      v-if="
                        currentQuestion.question_type ==
                          questionTypes.MATRIX_MATCH
                      "
                    />
                    <MatrixMatchOption
                      :showNextButton="showNextButton"
                      :isEditable="isEditable"
                      :question="currentQuestionToBeEdited"
                      v-if="
                        currentQuestion.question_type ==
                          questionTypes.MATRIX_MATCH_OPTION
                      "
                    />
                    <Comprehensions
                      :showNextButton="showNextButton"
                      :isEditable="isEditable"
                      :question="currentQuestionToBeEdited"
                      v-if="
                        currentQuestion.question_type ==
                          questionTypes.COMPREHENSION
                      "
                    />
                    <TC
                      :showNextButton="showNextButton"
                      :isEditable="isEditable"
                      :question="currentQuestionToBeEdited"
                      v-if="currentQuestion.question_type == questionTypes.TC"
                    />
                    </div>
                  </div>
                  <div  :class="$refs.previewName ? $refs.previewName.offsetHeight>52 ? 'preview-test-6feb' : '': '' " v-else>
                    <div 
                    ref="previewName"
                       class="chapter-name-row print-name preview-test-dropdown-block test-preivew-1-feb"
                      :class="{
                        'with-dropdown': isSearchAnotherQ,
                      }" v-if="isPreview">
                     <div class="chapter-name-outer-cp3">
                      <div class="chapter-name-row-cp3">
                      <div class="chapter-label search-another-label" v-if="!isSearchAnotherQ">
                        Chapter Name -
                      </div>
                      

                      <div class="chapter-drop search-another-drop"  v-if="
                            !isSearchAnotherQ
                        ">
                       <v-tooltip left  bottom content-class="cust-new-tooltip-top open-top">
			                  <template  v-slot:activator="{ on }">
                                            
                          <div
                          v-on="on"
                          depressed
                              :class="{
                              'text-transform-none': true,
                              'btn-center': true,
                              'btn-default': true,
                          }"
											
											>{{currentQuestion.chapterName }}</div
											>
                                            
											
										</template>
										<span > {{ currentQuestion.chapterName }} </span>
										</v-tooltip>
                      </div>
                      <div
                        v-if="
						currentQuestion.topicName &&
                            !isSearchAnotherQ && this.isDBTest
                        "
                        class="chapter-label search-another-label-2"
                      >
                        Topic Name -
                      </div>
                      <div
                        class="chapter-drop search-another-drop"
                        v-if="
						currentQuestion.topicName&&
                            !isSearchAnotherQ && this.isDBTest
                        "
                      >
                        <v-tooltip left  bottom content-class="cust-new-tooltip-top open-top">
			                  <template  v-slot:activator="{ on }">
                                            
                          <span
                          v-on="on"
                          depressed
                              :class="{
                              'text-transform-none': true,
                              'btn-center': true,
                              'btn-default': true,
                          }"
											
											>{{currentQuestion.topicName  }}</span
											>                     
											
										</template>
										<span > {{ currentQuestion.topicName  }} </span>
										</v-tooltip>
                      </div>
                      <div
                        class="chapter-label search-another-label-3"
                        v-if="
                         currentQuestion.difficultyName &&
                            !isSearchAnotherQ&& this.isDBTest
                        "
                      >
                        Level -
                      </div>
                      
                      <div
                        class="chapter-drop search-another-drop "
                        v-if="
						currentQuestion.difficultyName &&
                            !isSearchAnotherQ && isDBTest
                        "
                      >
                       
                        
                        <v-tooltip left  bottom content-class="cust-new-tooltip-top search-another-drop-easy open-top">
			                  <template  v-slot:activator="{ on }">
                                            
                          <span
                          v-on="on"
                          depressed
                              :class="{
                              'text-transform-none': true,
                              'btn-center': true,
                              'btn-default': true,
                          }"
											
											>{{ currentQuestion.difficultyName}}</span
											>                     
											
										</template>
										<span > {{ currentQuestion.difficultyName  }} </span>
										</v-tooltip>
                        
                      </div>
                      <div class="chapter-name-row isSearchAnothe-chapter" v-if="isSearchAnotherQ">
                      <div class="isSearchAnothe-chapter-col ch-margin-btn-10">
                        <div class="chapter-label">
                          Chapter Name
                        
                        </div>
                        <div class="chapter-drop">
                          <v-select
                            v-model="slectedChapter"
                            @change="getTopics()"
                            :items="chapters"
                            hide-details
                            dense
                            outlined
                            ref="chapterName"
                            class="dropdown-fix-160"
                          ></v-select>
                        </div>

                        <div class="chapter-label chapter-label-2">
                          Topic Name
                          
                        </div>
                        <div class="chapter-drop">
                          <v-select
                            v-model="selectedTopic"
                            @change="getSubTopics()"
                            :items="topics"
                            hide-details
                            dense
                            outlined
                            ref="chapterName"
                            class="dropdown-fix-160"
                          ></v-select>
                        </div>

                        <div class="chapter-label chapter-label-3">
                          Level
                        
                        </div>
                        <div class="chapter-drop">
                          <v-select
                            v-model="selectedDifficultyLevel"
                            :items="difficulty"
                            hide-details
                            dense
                            outlined
                            ref="chapterName"
                            class="dropdown-fix-160" 
                          ></v-select>
                        </div>
                        </div>
                        </div>
                </div>

               
                </div>
                <div class="btn-search-another-question last-used">
                       <v-btn v-if="user"
                        class="current-question-info last-created-btn"
                        :class="currentQuestion && currentQuestion.last_created_at ? '' : 'remove-pointer'"
                      >
                      <v-tooltip v-if="currentQuestion && currentQuestion.last_created_at"
                         bottom :close-delay="1000" content-class="cust-new-tooltip-bottom search-another-drop-easy tooltip-left open-top">
                        <template v-slot:activator="{ on }">
                          <span v-on="on" depressed :class="{'text-transform-none': true,'btn-center': true,'btn-default': true,}">
                            <span class="last-info">Last Used </span>
                            <br> <strong> {{currentQuestion.last_created_at ? currentQuestion.last_created_at : 'NEVER'}} </strong>
                          </span>
                        </template>
                        <span>
                          <div class="history-data-parent">
                            <div class="r-body ">
                              <div class="history-data">
                                <span class="center-width"><strong>Date </strong></span>
                                <span>{{ currentQuestion.last_created_at }}</span>
                              </div>

                            </div>
                          </div>
                        </span>
                      </v-tooltip>
                      <span v-else  class="last-info">Last Used <br> <strong> {{currentQuestion.last_created_at ?  currentQuestion.last_created_at : 'NEVER'}} </strong></span>
                      </v-btn>
                      <v-btn  class="current-question-info usage-details-btn"  @click="openHistoryDialog()">
                        <span class="view-week">Usage Details </span>
                      </v-btn>
                      <v-btn
                        v-if="isPreview && isTestCustom && this.isDBTest"
                        color="primary"
                        :disabled="!isEditableTest || isEditable"
                        @click="searchAnotherQ()"
                        class="right-btn cust-btn"
                      >
                       {{ isSearchAnotherQ ? 'Search Another Question' : 'Replace this Question' }} 
                      </v-btn>
                    
                    </div>
                    </div>
                    <div class="cp3privew-test-bk cp3-17-april" :class="{'without-search-height-control' : !isSearchAnotherQ, 'with-search-height-control' : isSearchAnotherQ}">
                    <Comprehension
                      :showAnswerField="questionData.showAnswerField"
                      :currentQuestion="currentQuestion"
                      :isPreview="isPreview"
                      v-if="
                        currentQuestion.question_type ==
                          questionTypes.COMPREHENSION ||
                          currentQuestion.question_type == questionTypes.TC
                      "
                    />
                    <SingleAnsQuePrivew
                      :showAnswerField="questionData.showAnswerField"
                      :currentQuestion="currentQuestion"
                      :openMandatoryQuePopup="openMandatoryQuePopup"
                      v-if="
                        currentQuestion.question_type ==
                          questionTypes.SINGLE_CORRECT ||
                         currentQuestion.question_type ==
                           questionTypes.SINGLE_CORRECT_SEC2 ||
						  currentQuestion.question_type ==
                            questionTypes.ASSERTION_REASON
                      "
                    />
                    <MultipleCorrectPrivew
                      :showAnswerField="questionData.showAnswerField"
                      :currentQuestion="currentQuestion"
                      :openMandatoryQuePopup="openMandatoryQuePopup"
                      v-if="
                        currentQuestion.question_type ==
                          questionTypes.MULTIPLE_CORRECT
                      "
                    />
                    <IntegerPrivew
                      :showAnswerField="questionData.showAnswerField"
                      :currentQuestion="currentQuestion"
                      v-if="
                        currentQuestion.question_type == questionTypes.INTEGER
                      "
                    />
                    <SubjectivePrivew
                      :showAnswerField="questionData.showAnswerField"
                      :currentQuestion="currentQuestion"
                      :isPreview="isPreview"
                      :openMandatoryQuePopup="openMandatoryQuePopup"
                      v-if="
                        currentQuestion.question_type ==
                          questionTypes.SUBJECTIVE ||
                          currentQuestion.question_type ==
                          questionTypes.SUBJECTIVEINTEGER
                      "
                    />
                    <MatrixMatchPrivew
                      :showAnswerField="questionData.showAnswerField"
                      :currentQuestion="currentQuestion"
                      :openMandatoryQuePopup="openMandatoryQuePopup"
                      v-if="
                        currentQuestion.question_type ==
                          questionTypes.MATRIX_MATCH
                      "
                    />

                    <MatrixMatchOptionPrivew
                      :showAnswerField="questionData.showAnswerField"
                      :currentQuestion="currentQuestion"
                      :openMandatoryQuePopup="openMandatoryQuePopup"
                      v-if="
                        currentQuestion.question_type ==
                          questionTypes.MATRIX_MATCH_OPTION
                      "
                    />
                  </div>
                  </div>
                </div>
              </div>
            </pinch-zoom>
          </v-card>
        </div>
        <div class="test-counter-block show-desktop-panel">
          <div class="test-time-count">
            <div class="time-remaining-title">
              <v-btn
                v-if="isPreview && isTestCustom"
                @click="similarQuestionsPopup"
                class="question-bucket right-align "
                :class="{
                  active:
                    !isSearchAnotherQ &&
                    !isUploadAndReplace &&
                    currentQuestion.institute_id === null && isEditableTest,
                }"
                ><div>
                  <div class="Bucket-que">Show All</div>
                  <div class="Bucket-select">
                    Questions of Same Topic
                  </div>
                </div></v-btn
              >
            </div>
            <div class="time-remaining-count">&nbsp;</div>
          </div>
          <div class="inner-block preview-test-cp3-public">
            <v-expansion-panels v-model="panel">
              <v-expansion-panel class="number-contet" expand v-model="panel">
                <v-expansion-panel-header
                  >Question Palette</v-expansion-panel-header
                >
                <v-expansion-panel-content>
                  <div class="number-contet"  >
                    <LegendsPreview
                      v-if="questionData"
                      :questionStatus="questionStatus"
                      :questions="questionData.questions"
                      :isPreview="isPreview"
                      :isCustom="isTestCustom"
                    />
                    <div class="hr-div"></div>
                    <QuestionPallet
                      v-if="questionData"
                      @jumpToQuestion="jumpToQuestion"
                      :isEditing="isEditing"
                      :isPreview="isPreview"
                      :isPastTest="isPastTest"
                      :isCustom="isTestCustom"
                      :questionData="questionData"
                    />
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
            <div class="test-foter-blk">
              <div
                class="test-btn-block-ans"
                :class="isPreview ? ' smallFont ' : 'cp3-makingt-text'"
              >
			  <div class="marking marking-bold" >
									{{questionData && questionData.mandatoryQuestions && (questionData.mandatoryQuestions.allow_all ===1 || questionData.mandatoryQuestions.allow_all ===0) ? `Out of the ${questionData.questions.length} Questions ${questionData.mandatoryQuestions.mandatory_questions} are Mandatory`: "All Questions in this section are Mandatory"}}
								
								</div>
								<div class="marking">
									{{questionData && questionData.mandatoryQuestions ? questionData.mandatoryQuestions.allow_all ===1 ? `You can answer all questions but the best  ${questionData.mandatoryQuestions.mandatory_questions} shall be evaluated`:
                  `You can only answer the mandatory number of questions`: ""}}
								</div>

                <div class="marking marking-bold">
                  Marking Scheme for this section:
                </div>
                <div class="marking">
                  Correct Response:+
                  {{ currentQuestion.correct_marks }}
                </div>
                <div class="marking">
                  Incorrect Response:{{ currentQuestion.negative_marks }}
                </div>
                <div
                  class="marking"
                  v-if="isPreview && currentQuestion.partial_marking > 0"
                >
                  <v-icon small color="success">mdi-checkbox-marked</v-icon>
                  Partial Marking:{{ currentQuestion.partial_marking }}
                </div>
                <div
                  v-if="isPreview && currentQuestion.partial_marking == 0"
                  class="marking markingElse"
                >
                  <v-icon small color="success">mdi-checkbox-marked</v-icon>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="test-bottom">
        <div class="bottom-logo">
          <!-- <img src="/img/logo-footer.c1b83f14.png" class="master-logo-btm" /> -->
        </div>
        <div class="test-btn-block-answering v-r-priview-test-view">
          <div class="save-and-next-btn save-finish-btn">
            
            <div class="mobile-upload-btn">
              <v-btn
                v-if="
                  isPreview &&
                    !isUploadAndReplace &&
                    (!isTestCustom || currentQuestion.institute_id === null)
                "
                :disabled="isEditing || isAnswerBtnClicked"
                color="primary"
                @click="openReportErrorDialog()"
                class="cust-btn"
              >
                Report Error
              </v-btn>
              <v-btn
                v-if="
                  isPreview &&
                   (isSearchAnotherQ || isUploadAndReplace)
                "
                color="primary"
                @click="replaceToOriginal()"
                class="cust-btn"
              >
                Revert To Original
              </v-btn>
              <v-btn
                color="primary"
                v-else-if="
                  isPreview &&
                    isTestCustom &&
                    currentQuestion.institute_id !== null
                "
                @click="editQuestion"
                class="cust-btn"
                >{{ isEditing ? "Done" : "Edit" }}</v-btn
              >
            </div>
            <v-btn
              color="primary"
              v-if="isTestCustom && isUploadAndReplace"
              @click="uploadAndReplace"
              class="cust-btn right-align"
            >
              Done</v-btn
            >
            <v-btn
              color="primary"
              v-if="isTestCustom && isSearchAnotherQ"
              @click="replaceSearchAnotherQuestion"
              class="cust-btn right-align"
            >
              Select Question</v-btn
            >
            <v-btn
              v-else-if="isPreview && !isSearchAnotherQ && !isUploadAndReplace"
              color="primary"
              :disabled="isEditing"
              @click="updateQuestionStatus(QUESTION_ACTIONS.SUBMIT)"
              class="cust-btn right-align"
            >
              Next
            </v-btn>
            
          </div>
          <div class="finish-test-btn">
            <v-btn
              color="default"
              class="cust-btn finish-test"
              @click="finishTest()"
              :disabled="
                disableSecondaryAction || isSearchAnotherQ || isUploadAndReplace
              "
              > Close Preview </v-btn
            >
          </div>
        </div>
      </div>
    </div>
    <AlertBox
      :width="modalWidth"
      :onClose="onClose"
      :component="cComponent"
      :status="status"
      :data="alertBoxData"
    />
  </div>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";
import isMobile from "is-mobile";
import moment from "moment";
import momentDuration from "moment-duration-format";
momentDuration(moment);

import { mapActions, mapState, mapMutations, mapGetters } from "vuex";

import QuestionPallet from "@/components/PreviewTest/QuestionPallet.vue";
import MiniQuestionPallet from "@/components/PreviewTest/MiniQuestionPallet.vue";
import LegendsPreview from "@/components/PreviewTest/LegendsPreview.vue";
import LegendsOnHover from "@/components/PreviewTest/LegendsOnHover.vue";
import Comprehension from "@/components/PreviewTest/Comprehension.vue";
import SingleAnsQuePrivew from "@/components/PreviewTest/SingleAnsQuePrivew.vue";
import MultipleCorrectPrivew from "@/components/PreviewTest/MultipleCorrectPrivew.vue";
import IntegerPrivew from "@/components/PreviewTest/IntegerPrivew.vue";
import SubjectivePrivew from "@/components/PreviewTest/SubjectivePrivew.vue";
import AssertionReasonPrivew from "@/components/PreviewTest/AssertionReasonPrivew.vue";
import MatrixMatchOptionPrivew from "@/components/PreviewTest/MatrixMatchOptionPrivew.vue";
import MatrixMatchPrivew from "@/components/PreviewTest/MatrixMatchPrivew.vue";

// importing components for edit mode
import SingleAnsQue from "@/components/QuestionType/SingleAnsQue.vue";
import MultipleCorrect from "@/components/QuestionType/MultipleCorrect.vue";
import Subjective from "@/components/QuestionType/Subjective.vue";
import Integer from "@/components/QuestionType/Integer.vue";
import MatrixMatchOption from "@/components/QuestionType/MatrixMatchOption.vue";
import MatrixMatch from "@/components/QuestionType/MatrixMatch.vue";
import Comprehensions from "@/components/QuestionType/Comprehensions.vue";
import TC from "@/components/QuestionType/TC.vue";

// importing axios to cancel heartbeat request if it is pending state till the next heartbeat is called
import axios from "axios";
import NoSleep from 'nosleep.js';
import constants from "@/utils/constants.js";
let noSleep = new NoSleep();

export default {
  name: "PreviewTest",
  components: {
    QuestionPallet,
    MiniQuestionPallet,
    LegendsPreview,
    LegendsOnHover,
    Comprehension,
    SingleAnsQuePrivew,
    MultipleCorrectPrivew,
    IntegerPrivew,
    SubjectivePrivew,
    AssertionReasonPrivew,
    MatrixMatchOptionPrivew,
    MatrixMatchPrivew,
    SingleAnsQue,
    MultipleCorrect,
    Subjective,
    Integer,
    MatrixMatchOption,
    MatrixMatch,
    Comprehensions,
    TC,
    Carousel,
    Slide,
  },
  async mounted() {
    document.addEventListener("visibilitychange", () => {
      // Modify behavior…
    });
     this.requestGetTestDetails();
    // sessionStorage.removeItem('limitCrossed')
	  localStorage.removeItem("searchedQuestion");
        localStorage.removeItem("currentQuestion");
    this.dummyOptions = [
      {
        index: this.OPTIONS_ABC[0],
        option_text: "",
        correct_answer: false,
      },
      {
        index: this.OPTIONS_ABC[1],
        option_text: "",
        correct_answer: false,
      },
      {
        index: this.OPTIONS_ABC[2],
        option_text: "",
        correct_answer: false,
      },
      {
        index: this.OPTIONS_ABC[3],
        option_text: "",
        correct_answer: false,
      },
    ];
    this.dummyOptionsABC = [
      {
        index: this.OPTIONS_ABC[0],
        option_text: "",
        column: 1,
        correct_answer: "",
      },
      {
        index: this.OPTIONS_ABC[1],
        option_text: "",
        column: 1,
        correct_answer: "",
      },
    ];
    this.dummyOptionsPQR = [
      {
        index: this.OPTIONS_PQR[0],
        option_text: "",
        column: 2,
        correct_answer: "",
      },
      {
        index: this.OPTIONS_PQR[1],
        option_text: "",
        column: 2,
        correct_answer: "",
      },
    ];
    this.innerWidth=window.innerWidth;
    this.questionTypes = this.QUE_TYPES;
    this.questionStatus = this.QUESTION_STATUS;
    this.questionStatusColor = this.QUESTION_STATUS_COLOR;
    this.setIsPastTest(false);
    await this.setCustomData();
    this.reverseQuestionsType();



    this.renderMath();
    if (this.isPreview) {
      
      this.getSkillSets();
    }
    this.setDisableSecondaryAction(false);
  },
  data() {
    return {
      isPastTest: false,
      is_preview: true,
      modalWidth: '1000px',
      instructionsTooltip: null,
      cComponent: "components/coordinator/Questionadd",
      alertBoxData: {},
      persistent: false,
      status: false,
      testDetails: null,
      questionTypes: this.QUE_TYPES,
      questionStatus: this.QUESTION_STATUS,
      questionStatusColor: this.QUESTION_STATUS_COLOR,
      questionTypesReversed: {},
      questionsList: {},
      questionData: {},
      panel: 0,
      questions: [],
      currentQuestion: {},
      legendsData: {
        answered: 0,
        reviewLater: 0,
        answeredReviewLater: 0,
        notVisited: 0,
        notAnswered: 0,
        easy: 0,
        moderate: 0,
        tough: 0,
      },
      instructions: "",
      isEditing: false,
      currentQuestionToBeEdited: {},
      showNextButton: false,
      isTestCustom: true,
      isPreview: true,
      scrollPerPage: false,
      direction: "",
      endAction: "",
      duration: null,
      timeRemainingString: "",
      timeRemainingInterval: null,
      heartBeatInterval: null,
      isOnline: true,
      timeObj: null,
      chapters: [],
      perPageCustom: [
        [1900, 6],
        [1650, 5],
        [1550, 4],
        [1400, 3],
        [1300, 3],
        [1280, 3],
        [1024, 2],
        [768, 2],
        [480, 1],
        [340, 1],
      ],
      pageStatus: [],
      pageInactive: false,
      inactiveStartTime: null,
      nextQuestionIndex: 0,
      showNextQuestion: true,
      isSQTChanged: false,
      isAnswerBtnClicked: false,
      scrollQtypeValue: null,
      isBlurred: false,
      hideTimer: false,
      finishTestError: null,
      responseTimeOut: null,
      cancelBeatSource: null,
      showTimer: false,
      expansionPanelStatus: [],
      remainingTimeInterval: null,
      testAutoFinished: false,
      topics: [],
      concepts: [],
      skillset: [],
      selectedTopic: {},
      difficulty: constants.DIFFICULTY_LEVELS,
      studentResponse: constants.ROLES.ST_ROLE_CODE,
      selectedDifficultyLevel: {},
      selectedSubTopic: {},
      selectedConcept: {},
      searchAnotherQuestions: {},
      isSearchAnotherQ: false,
      isUploadAndReplace: false,
      isEditable: false,
      teacherSubjectId: [],
    dummyOptionsPQR: [],
    dummyOptions: [],
    dummyOptionsABC: [],
	AssignedTeacher:[],
	questionAnsweredCount:0,
	isCallBucketApi: false,
	isDBTest:false,
  isOnlineTest:true,
  noOfTimesTabChanged:0,
  autoSubmitEndAction:"",
  autoSubmitError:"",
  navigateTo:0,
  isApiCall:true,
  isEditableTest: false,
  innerWidth:"",
  paperCoverage: []
    };
  },

  destroyed() {
  },
  computed: {
    ...mapState("userStore", ["user", "pendingTestList",'myInstitute']),

    ...mapGetters("testStore", {
      questionsListStore: "questionsList",
      filteredQuestionsList: "filteredQuestionsList",
      testData: "testData",
      subjectQuestionTypeList: "subjectQuestionTypeList",
      selectedSQTIndex: "selectedSQTIndex",
      disableSecondaryAction: "disableSecondaryAction",
    }),
    isLastQuestion() {
      if (
        this.subjectQuestionTypeList &&
        this.selectedSQTIndex == this.subjectQuestionTypeList.length - 1 &&
        this.questionData.currentQuestionIndex == this.questions.length - 1
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {
    instructionsTooltip(val) {
      this.renderMath();
    },
    // status(val){
    // 	if(!val){
    // 		this.requestGetTestDetails();
    // 	}
    // },
    // selectedSQTIndex(newVal) {
    // this.getQuestionData();
    // this.renderMath();
    // },
    subjectQuestionTypeList(newVal) {
      this.endAction = this.QUESTION_ACTIONS.TEST_STARTED;
      this.showNextQuestion = true;
      this.getQuestionData();
      this.renderMath();
    },
  },
  methods: {
    ...mapActions({
      setTestData: "testStore/setTestData",
      remainingTime: "testStore/remainingTime",
      setSubjectQuestionTypeList: "testStore/setSubjectQuestionTypeList",
      setFilteredQuestionsList: "testStore/setFilteredQuestionsList",
      setSelectedSQTIndex: "testStore/setSelectedSQTIndex",
      setSelectedQuestionIndex: "testStore/setSelectedQuestionIndex",
      getMYTPreviewDetails: "testStore/getMYTPreviewDetails",
      getLiveTestDetails: "testStore/getLiveTestDetails",
      setQuestions: "questionStore/setQuestions",
      createTest: "testStore/createTest",
      replaceQuestion: "testStore/replaceQuestion",
      updateProgressInDB: "testStore/updateProgressInDB",
      updateHeartBeat: "testStore/updateHeartBeat",
      setIsTestStarted: "testStore/setIsTestStarted",
      setPendingTestList: "userStore/setPendingTestList",
      getDataTreeWithLevel: "utilStore/getDataTreeWithLevelPublic",
      setDisableSecondaryAction: "testStore/setDisableSecondaryAction",
      logOut: "userStore/logOut",
      searchAnotherMytQuestion: "testStore/searchAnotherMytQuestion",
      setPendingTestList: "userStore/setPendingTestList",
      getTeacherSubject: "userStore/getTeacherSubject",
      replaceTestQuestion: "testStore/replaceTestQuestion",
      assignTestStatus: "testStore/assignTestStatus",
      setAnswerCount: "testStore/setAnswerCount",
      getRefData: "utilStore/getMYTRefData",
      getQuestionUsageDetails: "testStore/getQuestionUsageDetails",
      autoSubmit: "testStore/autoSubmit",
      logData: "testStore/logData",
      uploadAndReplaceMytQuestion: "testStore/uploadAndReplaceMytQuestion",
    }),
    ...mapMutations("testStore", ["setIsPastTest"]),
    // onClose(data) {
    //   this.status = data.status;
    //    if(data.reload){
    // 	  this.requestGetTestDetails();
    //   }
    // },
    openReportErrorDialog() {
      if(this.user){
        this.alertBoxData = {
          question: this.currentQuestion,
          errorDescription: "",
        };
        this.modalWidth = "1000px";
        this.status = true;
        this.cComponent = "components/student/Tests/PastTests/ReportError";
        this.$forceUpdate();
      }else{
        this.$toasted.error(
            "Please sign up to report an error."
          );
      }
    },
    getChapters(subjectId,subSubject) {
      if (subjectId && this.isPreview) {
        this.chapters = [];
        let reqData = {
          level: 3,
          parent: subjectId,
          sub_subject:subSubject
        };
        // this.$root.showLoader = true;
        this.getDataTreeWithLevel(reqData)
          .then((response) => {
            // this.$root.showLoader = false;
            this.chapters = response.map((x) => {
              let c = {};
              c.text = x.title;
              c.value = { chapter_id: x.id, title: x.title };
              return c;
            });
          })
          .catch((err) => {
            // this.$root.showLoader = false;
          });
      }
    },
    getTopics(chapterId) {
      if ((chapterId || this.slectedChapter.chapter_id)&& this.isPreview) {
        let reqData = {
          level: 4,
          parent: chapterId || this.slectedChapter.chapter_id,
        };
       // this.selectedSubTopic = {};
        this.subTopics = [];
        //this.selectedConcept = {};
        this.concepts = [];
        // this.$root.showLoader = true;
		if(this.isSearchAnotherQ){
			this.selectedTopic.topic_id = null;
			this.selectedTopic.title = null;
		}
        
        this.getDataTreeWithLevel(reqData)
          .then((response) => {
            // this.$root.showLoader = false;
            this.topics = response.map((x) => {
              let c = {};
              c.text = x.title;
              c.value = { topic_id: x.id, title: x.title };
              return c;
            });
          })
          .catch((err) => {
            // this.$root.showLoader = false;
          });
      }
    },
    
    onSelectChapter(e) {
      sessionStorage.removeItem("selectedQuestionIds");

      if (this.currentQuestionToBeEdited) {
        this.currentQuestionToBeEdited.chapterId = e.chapter_id;
        this.currentQuestionToBeEdited.chapterName = e.title;
      }
      if (this.currentQuestion) {
        this.currentQuestion.chapterId = e.chapter_id;
        this.currentQuestion.chapterName = e.title;
      }
      this.selectedSubTopic.subtopic_id = null;
      this.selectedTopic.topic_id = null;
      this.selectedTopic.title = null;
      this.getTopics(e.chapter_id);
    },
    onSelectedTopic(e) {
      sessionStorage.removeItem("selectedQuestionIds");

      if (this.currentQuestionToBeEdited) {
        this.currentQuestionToBeEdited.topic_id = e.topic_id;
        this.currentQuestionToBeEdited.topicName = e.title;
      }
      if (this.currentQuestion) {
        this.currentQuestion.topic_id = e.topic_id;
        this.currentQuestion.topicName = e.title;
      }
      this.getSubTopics(e.topic_id);
      //this.getConcepts(e.topic_id);

    },
    onselectedDifficulty(e) {
      sessionStorage.removeItem("selectedQuestionIds");

      if (this.currentQuestionToBeEdited) {
        this.currentQuestionToBeEdited.difficultyId = e.id;
        this.currentQuestionToBeEdited.difficultyName = e.title;
      }
      if (this.currentQuestion) {
        this.currentQuestion.difficultyId = e.id;
        this.currentQuestion.difficultyName = e.title;
      }
    },
   
    scrollToTop() {
      let content = this.$refs.questionBox;
      if (content) content.scrollTop = 0;
      let scrollElem = document.getElementsByClassName("v-application--wrap");
      scrollElem[0].scrollIntoView();
    },
    gotoDirection(scrollPerPage, direction) {
      this.direction = direction;
      // this.scrollPerPage = scrollPerPage;
      this.$refs.carousel.currentPage = Math.round(
        this.$refs.carousel.offset / this.$refs.carousel.slideWidth
      );
      if (
        this.direction == "backward" &&
        this.$refs.carousel.currentPage == 1
      ) {
        this.$refs.carousel.handleNavigation(this.direction);
        return;
      }
      this.scrollPerPage = scrollPerPage;
      this.$refs.carousel.currentPage = this.scrollPerPage
        ? Math.round(
            this.$refs.carousel.offset /
              this.$refs.carousel.slideWidth /
              this.$refs.carousel.currentPerPage
          )
        : Math.round(
            this.$refs.carousel.offset / this.$refs.carousel.slideWidth
          );
      this.$refs.carousel.handleNavigation(this.direction);
    },
    finishTest() {
        if (this.isEditing) {
          this.$toasted.error(
            "The changes you have made to this question have not been saved. Please click on Done to save the changes."
          );
        } else {
          this.removeCookie();
          this.redirectAsTypePreview();
        }
    },
    removeCookie() {
      let currentTestCookieExists = this.$cookies.isKey("CATAPULT_TEST");
      if (currentTestCookieExists) {
        this.$cookies.remove("CATAPULT_TEST");
      }
    },
    redirectAsTypePreview() {
      this.$router.push({ name: 'my-tests' });
    },
    showInstructions() {
      this.alertBoxData = {};
      this.alertBoxData.selectedTest = {
        instructions: this.instructions,
      };
      this.modalWidth = "1000px";
      this.status = true;
      this.cComponent = "components/coordinator/Tests/InstructionsPopup";
      this.$forceUpdate();
    },
    setCustomData() {
      let routeName = this.$route.name;
      if (
        routeName == "preview-test" ||
        routeName == "result-anaylysis-preview-test"
      ) {
        this.hideTimer = true;
        this.showTimer = false;
        this.isPreview = true;
      }
      if (this.isPreview && routeName == "preview-test") {
        localStorage.setItem("routeName", routeName);
      }
    },
    uploadAndReplace() {
      if (this.isUploadAndReplace) {
        // saving the edited data
        if (this.validation(this.currentQuestionToBeEdited)) {
          this.updateUploadAndReplace();
        }
      } else {
        // edit current question
        localStorage.setItem(
          "currentQuestion",
          JSON.stringify(this.currentQuestion)
        );
        this.currentQuestionToBeEdited = {};
        this.currentQuestionToBeEdited = _.cloneDeep(this.currentQuestion);
        this.currentQuestionToBeEdited = this.setDummyAnswerAsPerType(
          this.currentQuestion
        );
        if (
          this.currentQuestion.question_type ==
            this.questionTypes.COMPREHENSION ||
          this.currentQuestion.question_type == this.questionTypes.TC
        ) {
          this.currentQuestionToBeEdited.question_text = this.currentQuestion.passage;
          this.currentQuestionToBeEdited.id = this.currentQuestion.parent_id;
          let question = this.subjectQuestionTypeList[
            this.selectedSQTIndex
          ].questions.filter(
            (q) => q.parent_id && q.parent_id === this.currentQuestion.parent_id
          );
          this.currentQuestionToBeEdited.questions.forEach((ques) => {
            ques.passage = "";
            ques.question_text = "";
            ques.questionNo = "";
          });
          for (let i = 0; i < question.length; i++) {
            this.currentQuestionToBeEdited.questions[i].questionNo = question[i].questionNo;
          }
        }
        this.currentQuestionToBeEdited.question_text = "";
        (this.currentQuestionToBeEdited.solution = []),
          (this.selectedTopic = {});
        this.selectedDifficultyLevel = {};
        this.selectedSkillSet = {},
        this.slectedChapter = {};
        this.selectedSubTopic = {};
        this.selectedConcept = {};

        this.isUploadAndReplace = true;
        this.$forceUpdate();
        this.$nextTick(() => {
          this.$refs.chapterName.focus();
        });
      }
    },

    editQuestion() {
      if (this.isEditing) {
        // saving the edited data
        if (this.validation(this.currentQuestionToBeEdited)) {
          this.updateEditedQuestion();
        }
      } else {
        // edit current question
        this.currentQuestionToBeEdited = {};
        this.currentQuestionToBeEdited = _.cloneDeep(this.currentQuestion);
        if (
          this.currentQuestion.question_type ==
            this.questionTypes.COMPREHENSION ||
          this.currentQuestion.question_type == this.questionTypes.TC
        ) {
          this.currentQuestionToBeEdited.question_text = this.currentQuestion.passage;
          this.currentQuestionToBeEdited.id = this.currentQuestion.parent_id;
          let question = this.subjectQuestionTypeList[this.selectedSQTIndex].questions.filter(q=>q.parent_id && q.parent_id === this.currentQuestion.parent_id)
           this.currentQuestionToBeEdited.questions = [];
          question.map(q=>{
            this.currentQuestionToBeEdited.questions.push(
              _.cloneDeep(q)
            );

          })
        }

        this.getTopics(this.currentQuestion.chapterId)
        this.isEditing = true;
        this.getSubTopics(this.currentQuestion.topic_id)
        this.getConcepts(this.currentQuestion.subtopic_id)

        this.$forceUpdate();
        this.$nextTick(() => {
          this.$refs.chapterName.focus();
        });
      }
    },
    updateUploadAndReplace() {
      let stepOneData = {};
      let list = [];
      let forUpdate = true;
      let q = _.cloneDeep(this.currentQuestionToBeEdited);
      if (this.validate()) {
        this.$root.showLoader = true;

        let obj = {
          // id: q.id,
          question_text: q.question_text,
          question_type: q.questionType.id,
          subtype: q.subtype ? q.subtype : null,
          data_type_id: q.chapterId,
          topic_id: q.topic_id,
          subtopic_id: q.subtopic_id,
          concept_id: q.concept_id,
          answer_type: q.answer_type,
          time: q.time,
          difficulty: q.difficultyId,
          correct_marks: q.correct_marks.toString(),
          negative_marks: q.negative_marks.toString(),
          partial_marking: q.partial_marking.toString(),
          questions: q.questions
            ? q.questions.map((x) => {
                x.id = undefined;
                if (x.options) {
                  x.options.map((y) => {
                    y.id = undefined;
                    return y;
                  });
                }
                return x;
              })
            : null,
          solution: q.solution,
          hints: this.getHintsForRequest(q.hints),
          test_detail_id: q.test_detail_id,
          subject:
            q.subject_id ||
            (this.currentQuestion && this.currentQuestion.subject_id) ||
            null,
        };

        if (
          q.questionType.id === this.questionTypes.INTEGER ||
          q.questionType.id === this.questionTypes.SUBJECTIVE || 
          q.questionType.id === this.questionTypes.SUBJECTIVEINTEGER
        ) {
          obj.correct_answer = q.correct_answer;
        } else {
          obj.correct_answer = "-";
        }
        if (
          q.questionType.id === this.questionTypes.ASSERTION_REASON ||
          q.questionType.id === this.questionTypes.MULTIPLE_CORRECT ||
          q.questionType.id === this.questionTypes.SINGLE_CORRECT||
          q.questionType.id === this.questionTypes.SINGLE_CORRECT_SEC2
        ) {
          obj.options = q.options.map((x) => {
            x.id = undefined;
            return x;
          });
        } else if (q.questionType.id === this.questionTypes.MATRIX_MATCH) {
          obj.options = q.options_abc
            .map((x) => {
              x.id = undefined;
              return x;
            })
            .concat(
              q.options_pqr.map((x) => {
                x.id = undefined;
                return x;
              })
            );
        } else if (
          q.questionType.id === this.questionTypes.MATRIX_MATCH_OPTION
        ) {
          obj.options = q.options
            .map((x) => {
              x.id = undefined;
              return x;
            })
            .concat(
              q.options_abc.map((x) => {
                x.id = undefined;
                return x;
              })
            )
            .concat(
              q.options_pqr.map((x) => {
                x.id = undefined;
                return x;
              })
            );
        }
        list.push(obj);

        stepOneData.testName = this.testDetails.test_name;
        stepOneData.duration = this.testDetails.duration;
        stepOneData.selectedTarget = this.testDetails.target;
        stepOneData.testId = this.testDetails.id;
        stepOneData.testType = this.testDetails.test_type;

        let reqData = {
          list: list,
          target: stepOneData.selectedTarget,
          test_type: stepOneData.testType
            ? stepOneData.testType
            : this.TEST_TYPE.CUSTOM,
          duration: stepOneData.duration,
          test_name: stepOneData.testName,
          instructions: this.instructions,
          only_question: true,
          institute_id:this.myInstitute.id
        };

        if (stepOneData.testId) {
          reqData.id = stepOneData.testId;
        }
        obj.institute_id=this.myInstitute.id

        obj.target_exam = stepOneData.selectedTarget;
        this.uploadAndReplaceMytQuestion(obj)
          .then((response) => {
            this.$root.showLoader = false;
            this.$toasted.success(`${response.message}`, {
              icon: "check_circle",
            });
            this.isUploadAndReplace = false;
            this.updateSearchAnotherQuestion(
				response.questionData,
				this.currentQuestionToBeEdited,
            );
			this.currentQuestion.id = response.questionData.id
			this.currentQuestion.question_bucket_count = 0;
            this.currentQuestion.institute_id = this.user.institute;
            localStorage.removeItem("currentQuestion");
            if (
              q.questionType.id === this.questionTypes.COMPREHENSION ||
              q.questionType.id === this.questionTypes.TC
            ) {
              this.requestGetTestDetails();
            }
          })
          .catch((err) => {
            this.$root.showLoader = false;
          });
      }
    },
    updateEditedQuestion() {
      let stepOneData = {};
      let list = [];
      let forUpdate = true;
      let q = _.cloneDeep(this.currentQuestionToBeEdited);
	  if(this.validate()){
      this.$root.showLoader = true;
      let obj = {
        id: q.id,
        question_text: q.question_text,
        question_type: q.questionType.id,
        subtype: q.subtype ? q.subtype : null,
        data_type_id: q.chapterId,
        topic_id:q.topic_id,
        subtopic_id:q.subtopic_id,
        concept_id:q.concept_id,
        answer_type:q.answer_type,
        difficulty:q.difficultyId,
        correct_marks: q.correct_marks.toString(),
        negative_marks: q.negative_marks.toString(),
        partial_marking: q.partial_marking.toString(),
        questions: q.questions ? q.questions : null,
        solution: q.solution,
        hints: this.getHintsForRequest(q.hints),
        subject:
          q.subject_id ||
          (this.currentQuestion && this.currentQuestion.subject_id) ||
          null,
      };

      if (
        q.questionType.id === this.questionTypes.INTEGER ||
        q.questionType.id === this.questionTypes.SUBJECTIVE ||           
        q.questionType.id === this.questionTypes.SUBJECTIVEINTEGER
      ) {
        obj.correct_answer = q.correct_answer;
      } else {
        obj.correct_answer = "-";
      }
      if (
        q.questionType.id === this.questionTypes.ASSERTION_REASON ||
        q.questionType.id === this.questionTypes.MULTIPLE_CORRECT ||
      	q.questionType.id === this.questionTypes.SINGLE_CORRECT_SEC2 ||
	    q.questionType.id === this.questionTypes.SINGLE_CORRECT
      ) {
        obj.options = q.options;
			  obj.options.map(o=>{
	  delete o['id']
	  delete o['question_id']
	  })
      } else if (q.questionType.id === this.questionTypes.MATRIX_MATCH) {
        obj.options = q.options_abc.concat(q.options_pqr);
			  obj.options.map(o=>{
	  delete o['id']
	  delete o['question_id']
	  })
      } else if (q.questionType.id === this.questionTypes.MATRIX_MATCH_OPTION) {
        obj.options = q.options.concat(q.options_abc).concat(q.options_pqr);
			  obj.options.map(o=>{
	  delete o['id']
	  delete o['question_id']
	  })
      }

      list.push(obj);

      stepOneData.testName = this.testDetails.test_name;
      stepOneData.duration = this.testDetails.duration;
      stepOneData.selectedTarget = this.testDetails.target;
      stepOneData.testId = this.testDetails.id;
      stepOneData.testType = this.testDetails.test_type;

      let reqData = {
        list: list,
        target: stepOneData.selectedTarget,
        test_type: stepOneData.testType
          ? stepOneData.testType
          : this.TEST_TYPE.CUSTOM,
        duration: stepOneData.duration,
        test_name: stepOneData.testName,
        instructions: this.instructions,
        only_question: true,
        isEditable:true
      };

      if (stepOneData.testId) {
        reqData.id = stepOneData.testId;
      }

      this.createTest(reqData)
        .then((response) => {
          this.$root.showLoader = false;
          this.$toasted.success(`Success\n${response.msg}`, {
            icon: "check_circle",
          });
          this.isEditing = false;
          if (
              response.details.question_type === this.questionTypes.COMPREHENSION ||
              response.details.question_type === this.questionTypes.TC
            ) {
              this.requestGetTestDetails();
            }else{

              this.updateCurrentQuestions(
                this.currentQuestionToBeEdited,
                response.details
              );
            }

          this.scrollToTop();
        })
        .catch((err) => {
          this.$root.showLoader = false;
        });
	  }
    },

    //
    updateCurrentQuestions(q, qDetails) {
      this.currentQuestion.question_text = q.question_text;
      this.currentQuestion.solution = q.solution;
      this.currentQuestion.hints = q.hints;
	   this.currentQuestion.topic_id = q.topic_id;
      this.currentQuestion.topicName = q.topicName?q.topicName:q.topic
      ? q.topic.title
        : "";
    //   this.currentQuestion.subtopic = qDetails.subtopic;
     
      this.currentQuestion.subtopic_id = q.subtopic_id
      this.currentQuestion.subtopicName = q.subtopicName
       ? q.subtopicName:q.subtopic?q.subtopic.title
        : "";
    //   this.currentQuestion.concept = q.concept;

      this.currentQuestion.concept_id = q.concept_id
	       this.currentQuestion.conceptName = q.conceptName
       ? q.conceptName :q.concept?q.concept.title
        : "";
    //   this.currentQuestion.datatype =q.datatype;
      this.currentQuestion.subject_id =
        q.subject_id ||
        (q.datatype && q.datatype.parentDetails
          ? q.datatype.parentDetails.id
          : this.currentQuestion.subject_id || null);
      this.currentQuestion.chapterId = q.chapterId?q.chapterId: q.data_type_id;
      this.currentQuestion.chapterName =q.chapterName?q.chapterName: q.datatype
        ? q.datatype.title
        : "";
      this.currentQuestion.difficultyName =q.difficultyName?q.difficultyName:
        this.difficulty.find((d) => d.id === q.difficulty_level).title ||
        "";
      this.currentQuestion.difficultyId = q.difficultyId?q.difficultyId:
        this.difficulty.find((d) => d.id === q.difficulty_level).id || 0;
      this.currentQuestion.difficulty_level =q.difficultyId?q.difficultyId:
        this.difficulty.find((d) => d.id === q.difficulty_level).id || 0;
      this.currentQuestion.institute_id = !q.institute_id
        ? null
        : q.institute_id;
		this.currentQuestion.answer_type = q.answer_type?q.answer_type: q.answertype?q.answertype.id:null,
        this.currentQuestion.skillsetName = qDetails.skillsetName?qDetails.skillsetName:qDetails.answertype?qDetails.answertype.value:null;
     this.currentQuestion.question_view_count = 0
     this.currentQuestion.last_created_at = null
      let questionsToBeUpdated = null;
      let editedSubquestion = null;
      switch (this.currentQuestion.question_type) {
        case this.questionTypes.INTEGER:
          this.currentQuestion.correct_answer = q.correct_answer;
          break;

        case this.questionTypes.MATRIX_MATCH:
          this.currentQuestion.options_abc = qDetails.options.filter(
            (o) => o.column == 1
          );
          this.currentQuestion.options_pqr = qDetails.options.filter(
            (o) => o.column == 2
          );
          break;

        case this.questionTypes.MATRIX_MATCH_OPTION:
          this.currentQuestion.options_abc = qDetails.options.filter(
            (o) => o.column == 1
          );
          this.currentQuestion.options_pqr = qDetails.options.filter(
            (o) => o.column == 2
          );
          this.currentQuestion.options = qDetails.options.filter(
            (o) => o.column == null
          );
          break;

        case this.questionTypes.COMPREHENSION:
          questionsToBeUpdated = this.questions.filter(
            (qt) => qt.parent_id == q.parent_id
          );
          editedSubquestion = q.questions[0];
          questionsToBeUpdated.forEach((ques) => {
            ques.passage = q.question_text;
            if (ques.id == editedSubquestion.id) {
              ques.question_text = editedSubquestion.question_text;
              ques.options = editedSubquestion.options;
            }
          });
          break;

        case this.questionTypes.TC:
          questionsToBeUpdated = this.questions.filter(
            (qt) => qt.parent_id == q.parent_id
          );
          editedSubquestion = q.questions[0];
          questionsToBeUpdated.forEach((ques) => {
            ques.passage = q.question_text;
            if (ques.id == editedSubquestion.id) {
              ques.question_text = editedSubquestion.question_text;
              ques.options = editedSubquestion.options;
            }
          });
          break;

        case this.questionTypes.SUBJECTIVE:
        case this.questionTypes.SUBJECTIVEINTEGER:
          this.currentQuestion.correct_answer = q.correct_answer;
          if (q.questionType.id === this.questionTypes.SUBJECTIVE || q.questionType.id === this.questionTypes.SUBJECTIVEINTEGER) {
            this.currentQuestion.startValue = q.startValue;
            this.currentQuestion.endValue = q.endValue;
          }
          break;

        case this.questionTypes.ASSERTION_REASON:
          this.currentQuestion.options = q.options;
          break;

        case this.questionTypes.MULTIPLE_CORRECT:
          this.currentQuestion.options = q.options;
          break;

        case this.questionTypes.SINGLE_CORRECT:
         case this.questionTypes.SINGLE_CORRECT_SEC2:
			   this.currentQuestion.options = q.options;
          break;
      }
      this.renderMathData();
      this.renderMathData();
    },
    updateSearchAnotherQuestion(q, qDetails) {
      this.currentQuestion.id = qDetails.id;
      this.currentQuestion.parent_id = qDetails.parent_id;
      this.currentQuestion.question_text = qDetails.question_text;
      this.currentQuestion.passage = qDetails.passage?qDetails.passage:'';
      this.currentQuestion.solution = qDetails.solution;
      this.currentQuestion.hints = qDetails.hints;
		 this.currentQuestion.topic = qDetails.topic
      this.currentQuestion.topic_id = qDetails.topic_id;
      this.currentQuestion.topicName = qDetails.topicName?qDetails.topicName:qDetails.topic
      ? qDetails.topic.title
        : "";
      this.currentQuestion.subtopic = qDetails.subtopic;
     
      this.currentQuestion.subtopic_id = qDetails.subtopic_id
      this.currentQuestion.subtopicName = qDetails.subtopicName
       ? qDetails.subtopicName:qDetails.subtopic?qDetails.subtopic.title
        : "";
      this.currentQuestion.concept = qDetails.concept;

      this.currentQuestion.concept_id = qDetails.concept_id
	       this.currentQuestion.conceptName = qDetails.conceptName
       ? qDetails.conceptName :qDetails.concept?qDetails.concept.title
        : "";
      this.currentQuestion.datatype =qDetails.datatype;
      this.currentQuestion.subject_id =
        qDetails.subject_id ||
        (qDetails.datatype && qDetails.datatype.parentDetails
          ? qDetails.datatype.parentDetails.id
          : null);
      this.currentQuestion.dataType =qDetails.datatype;
        
      this.currentQuestion.chapterId = qDetails.chapterId?qDetails.chapterId: qDetails.data_type_id;
      this.currentQuestion.chapterName =qDetails.chapterName?qDetails.chapterName: qDetails.datatype
        ? qDetails.datatype.title
        : "";
      this.currentQuestion.difficultyName =qDetails.difficultyName?qDetails.difficultyName:qDetails.difficulty_level ?
        this.difficulty.find((d) => d.id === qDetails.difficulty_level).title :
        "";
      this.currentQuestion.difficultyId = qDetails.difficultyId?qDetails.difficultyId:qDetails.difficulty_level ?
        this.difficulty.find((d) => d.id === qDetails.difficulty_level).id :0;
      this.currentQuestion.difficulty_level =qDetails.difficultyId?qDetails.difficultyId: qDetails.difficulty_level ?
        this.difficulty.find((d) => d.id === qDetails.difficulty_level).id :0;
      this.currentQuestion.institute_id = !qDetails.institute_id
        ? null
        : qDetails.institute_id;
		this.currentQuestion.answer_type = qDetails.answer_type?qDetails.answer_type: qDetails.answertype?qDetails.answertype.id:null,
		 this.currentQuestion.skillsetName = qDetails.skillsetName?qDetails.skillsetName:qDetails.answertype?qDetails.answertype.value:null;
		 this.currentQuestion.question_view_count = qDetails.question_view_count;
     this.currentQuestion.last_created_at = qDetails.last_created_at ?moment(qDetails.last_created_at).format(constants.DATE_FORMATS.DISPLAY_DATE):null;
     this.$forceUpdate();
     let questionsToBeUpdated = null;
      let editedSubquestion = null;
      this.currentQuestion.question_bucket_count = qDetails.question_bucket_count ? qDetails.question_bucket_count: 0;
      switch (this.currentQuestion.question_type) {
        case this.questionTypes.INTEGER:
          this.currentQuestion.correct_answer = qDetails.correct_answer;
          break;

        case this.questionTypes.MATRIX_MATCH:
          if (qDetails.options && qDetails.options.length) {
            this.currentQuestion.options_abc = qDetails.options.filter(
              (o) => o.column == 1
            );
            this.currentQuestion.options_pqr = qDetails.options.filter(
              (o) => o.column == 2
            );
          } else {
            this.currentQuestion.options_abc = qDetails.options_abc;
            this.currentQuestion.options_pqr = qDetails.options_pqr;
          }

          break;

        case this.questionTypes.MATRIX_MATCH_OPTION:
          this.currentQuestion.options_abc = qDetails.options.filter(
            (o) => o.column == 1
          );
          this.currentQuestion.options_pqr = qDetails.options.filter(
            (o) => o.column == 2
          );
          this.currentQuestion.options = qDetails.options.filter(
            (o) => o.column == null
          );
          break;

        case this.questionTypes.COMPREHENSION:
			   this.currentQuestion.options = qDetails.options;

          break;

        case this.questionTypes.TC:
			   this.currentQuestion.options = qDetails.options;

          break;

        case this.questionTypes.SUBJECTIVE:
        case this.questionTypes.SUBJECTIVEINTEGER:
          this.currentQuestion.correct_answer = qDetails.correct_answer;
          if (qDetails.question_type === this.questionTypes.SUBJECTIVE || q.questionType.id === this.questionTypes.SUBJECTIVEINTEGER) {
			  if (qDetails.startValue && qDetails.endValue) {
				    this.currentQuestion.startValue = qDetails.startValue;
            		this.currentQuestion.endValue = qDetails.endValue;  
			  }else {
				  let answerArray = qDetails.correct_answer.split("##");
					if (answerArray.length == 2) {
					this.currentQuestion.startValue = answerArray[0];
					this.currentQuestion.endValue = answerArray[1];
					}
			  }

          }
          break;

        case this.questionTypes.ASSERTION_REASON:
          this.currentQuestion.options = qDetails.options;
          break;

        case this.questionTypes.MULTIPLE_CORRECT:
          this.currentQuestion.options = qDetails.options;
          break;

        case this.questionTypes.SINGLE_CORRECT:
         case this.questionTypes.SINGLE_CORRECT_SEC2:
			   this.currentQuestion.options = qDetails.options;
          break;
      }
      this.renderMathData();
      this.renderMathData();
    },
    showAllQuestions() {
      this.alertBoxData = {};
      this.alertBoxData.subjectQuestionTypeList = [];
      let subjectQuestionTypeList = this.subjectQuestionTypeList;
      subjectQuestionTypeList.forEach((sqt) => {
        let sqtObj = Object.assign({}, sqt);
        sqtObj.showAnswerField = false;
        this.alertBoxData.subjectQuestionTypeList.push(sqtObj);
      });
      this.modalWidth = "1000px";
      this.status = true;
      this.cComponent = "components/PreviewTest/QuestionPaper";
      this.$forceUpdate();
    },
    renderMathData() {
      this.renderMath();
    },
    getLegendsData(index) {
      this.legendsData = {
        answered: 0,
        reviewLater: 0,
        answeredReviewLater: 0,
        notVisited: 0,
        notAnswered: 0,
        easy: 0,
        moderate: 0,
        tough: 0,
      };
      let questions = [];
      if (index != null) {
        questions = this.subjectQuestionTypeList[index].questions;
      } else {
        questions = Object.values(this.filteredQuestionsList);
      }
      questions.forEach((val) => {
        if (val.status == this.questionStatus.ANSWER_SELECTED_SAVED) {
          this.legendsData.answered++;
        }
        if (val.status == this.questionStatus.ANSWER_NOT_SELECTED_REVIEW) {
          this.legendsData.reviewLater++;
        }
        if (val.status == this.questionStatus.ANSWER_SELECTED_REVIEW) {
          this.legendsData.answeredReviewLater++;
        }
        if (val.status < this.questionStatus.VISITED) {
          this.legendsData.notVisited++;
        }
        if (
          (val.status == this.questionStatus.VISITED && !val.isAnswered) ||
          val.status == this.questionStatus.ANSWER_NOT_SELECTED_SAVED
        ) {
          this.legendsData.notAnswered++;
        }
        if (val.difficulty_level === this.difficulty[0].id) {
          this.legendsData.easy++;
        }
        if (val.difficulty_level === this.difficulty[1].id) {
          this.legendsData.moderate++;
        }
        if (val.difficulty_level === this.difficulty[2].id) {
          this.legendsData.tough++;
        }

        if (val.difficulty_level === null && val.institute_id) {
          this.legendsData.moderate++;
        }
      });
    },
    getQuestionData() {
      this.questionData = this.subjectQuestionTypeList[this.selectedSQTIndex];
      this.questions = this.questionData.questions;
      this.scrollQtypeValue = 1;
      this.saveCurrentAction("nextQuestion");
      this.getChapters(this.questionData.questions[0].datatype.parentDetails.id,this.questionData.questions[0].sub_subject);
    },
    
    async updateQuestionStatus(ansStatus) {
      this.setDisableSecondaryAction(false);
      this.nextQuestionIndex = this.questionData.currentQuestionIndex + 1;

      this.saveCurrentAction("currentQuestion");
    },
    saveCurrentAction(type) {
      // let currentQuestion = this.currentQuestion;
        // this.currentQuestion = this.questions[];
        this.nextQuestion();

    },    
    setCurrentQuestions() {
      this.isSQTChanged = false;
      this.questionData = this.subjectQuestionTypeList[this.selectedSQTIndex];
      this.questions = this.questionData.questions;
      this.getChapters(this.questionData.questions[0].datatype.parentDetails.id,this.questionData.questions[0].sub_subject);
      this.isApiCall=false;
    },
    nextQuestion() {
		this.isCallBucketApi= true;
      this.expansionPanelStatus = null;
      sessionStorage.removeItem("selectedQuestionIds");
	  localStorage.removeItem("searchedQuestion");
        localStorage.removeItem("currentQuestion");
      // if subject question type is changed need to change the set of questions as selected type
      if (this.isSQTChanged) {
        this.setCurrentQuestions();
      }
		let count = 0;
			this.questions.map(q=>{
				if(q.isAnswered){
					count =count + 1;
				}
			})
			if(this.questionData.mandatoryQuestions && this.questionData.mandatoryQuestions.allow_all === 0) {
					if(count===this.questionData.mandatoryQuestions.mandatory_questions){
						this.questionData.questions.map(m =>{
							if(!m.isAnswered){
								m.isAnswerDisabled = true;
							}
						})
					}
					else {
						this.questionData.questions.map(m =>{
							m.isAnswerDisabled = false;
						})
					}
			}

      if (this.nextQuestionIndex == this.questions.length) {
        let nextSubjectQuestionTypeIndex = this.selectedSQTIndex + 1;
        if (
          nextSubjectQuestionTypeIndex < this.subjectQuestionTypeList.length
        ) {
          let nextType = this.subjectQuestionTypeList[
            nextSubjectQuestionTypeIndex
          ];

          this.setCurrentQuestionData(
            nextSubjectQuestionTypeIndex,
            nextType.currentQuestionIndex
          );
          this.nextQuestionIndex = nextType.currentQuestionIndex;
		  		this.questionAnsweredCount = nextType.qAnsweredCount;
          this.setCurrentQuestions();
        } else {
          this.isAnswerBtnClicked = false;
          this.showTimer = true;
          this.scrollToTop();
          return;
        }
      }
      // else {
      let typeIndex = this.selectedSQTIndex;
      this.setSelectedQuestionIndex({
        currentQuestionIndex: this.nextQuestionIndex,
        typeIndex,
      });
	  this.setAnswerCount({
				qAnsweredCount: this.questionAnsweredCount,
				typeIndex
			})

      this.currentQuestion = this.questions[this.nextQuestionIndex];
      this.$nextTick(() => {
        if (this.currentQuestion.status == this.questionStatus.INITIAL)
          this.currentQuestion.status = this.questionStatus.VISITED;
      });

      let storeCurrentQuestionCookie = {
        currentSQTIndex: this.selectedSQTIndex,
        currentQuestionIndex: this.nextQuestionIndex,
        // userId: this.user.id,
        testId: this.$route.params.test_id,
        testInstituteId: this.$route.params.test_institute_id,
      };
      this.$cookies.set("CATAPULT_TEST", storeCurrentQuestionCookie);
      // }
      if (this.currentQuestion) {
        this.slectedChapter = {
          chapter_id: this.currentQuestion.chapterId,
          title: this.currentQuestion.chapterName,
        };
        this.getTopics(this.slectedChapter.chapter_id);
      }
      if (this.currentQuestion) {
        this.selectedTopic = {
          topic_id: this.currentQuestion.topic_id,
          title: this.currentQuestion.topicName,
        };
        this.getSubTopics(this.currentQuestion.topic_id)
      }
      if (this.currentQuestion) {
        this.selectedDifficultyLevel = {
          id: this.currentQuestion.difficultyId,
          title: this.currentQuestion.difficultyName,
        };
      }
      if (this.currentQuestion) {
        this.selectedSkillSet = {
          id: this.currentQuestion.answer_type,
          title: this.currentQuestion.skillsetName,
        };
        // this.getSkillSets(this.currentQuestion.answer_type)
      }
      if (this.currentQuestion) {
        this.selectedSubTopic = {
          subtopic_id: this.currentQuestion.subtopic_id,
          title: this.currentQuestion.subtopicName,
        };
        this.getConcepts(this.currentQuestion.subtopic_id)
      }
       if (this.currentQuestion) {
        this.selectedConcept = {
          concept_id: this.currentQuestion.concept_id,
          title: this.currentQuestion.conceptName,
        };
        this.getSubTopics(this.currentQuestion.topic_id)
      }

      this.scrollToTop();
      setTimeout(async()=>await this.renderMath(),100);
      this.isAnswerBtnClicked = false;
      this.showTimer = true;

      if (this.scrollQtypeValue !== 1) {
        this.$refs.carousel.currentPage = this.$refs.carousel.scrollPerPage
          ? Math.round(
              this.$refs.carousel.offset /
                this.$refs.carousel.slideWidth /
                this.$refs.carousel.currentPerPage
            )
          : Math.round(
              this.$refs.carousel.offset / this.$refs.carousel.slideWidth
            );

        this.navigateTo = this.selectedSQTIndex;
      }
      if (this.isPreview) {
        
        this.getQuestionInfo();
      }
    },
    getAnswerAsPerType(q) {
      let answer = null;
      let selectedOption = null;
      let options = null;
      let questionType =
        q.question_type == this.questionTypes.COMPREHENSION ||
        q.question_type == this.questionTypes.TC
          ? q.subtype
          : q.question_type;

      if (
        questionType == this.questionTypes.TC_2Q_SA ||
        questionType == this.questionTypes.TC_3Q_SA ||
        questionType == this.questionTypes.COMPREHENSION_3Q_SA ||
        questionType == this.questionTypes.COMPREHENSION_2Q_SA ||
        questionType == this.questionTypes.COMPREHENSION_2Q_MM
      ) {
        questionType = this.questionTypes.SINGLE_CORRECT;
      } else if (
        questionType == this.questionTypes.COMPREHENSION_3Q_MA ||
        questionType == this.questionTypes.COMPREHENSION_2Q_MA
      ) {
        questionType = this.questionTypes.MULTIPLE_CORRECT;
      }
      switch (questionType) {
        case this.questionTypes.INTEGER:
          answer = q.correct_answer;
          break;

        case this.questionTypes.MATRIX_MATCH:
          options = [];
          q.options_abc.map((o, idx) => {
            if (o.correct_answer > "") {
              options.push({
                option_id: o.id,
                value: o.correct_answer,
              });
            }
          });
          answer = options.length > 0 ? options : null;
          break;

        case this.questionTypes.MATRIX_MATCH_OPTION:
          selectedOption = q.options.find(
            (option) => option.correct_answer == true
          );
          answer = selectedOption ? { option_id: selectedOption.id } : null;
          break;

        case this.questionTypes.SUBJECTIVE:
        case this.questionTypes.SUBJECTIVEINTEGER:
        case this.questionTypes.COMPREHENSION_2Q_NU:
          answer = {};
          answer = q.correct_answer;
          break;

        case this.questionTypes.ASSERTION_REASON:
          selectedOption = q.options.find(
            (option) => option.correct_answer == true
          );
          answer = selectedOption ? { option_id: selectedOption.id } : null;
          break;

        case this.questionTypes.MULTIPLE_CORRECT:
          options = [];
          q.options.map((o, idx) => {
            if (o.correct_answer == true) {
              options.push(o.id);
            }
          });
          answer = options.length > 0 ? { option_id: options } : null;
          break;

        case this.questionTypes.SINGLE_CORRECT:
         case this.questionTypes.SINGLE_CORRECT_SEC2:
			   selectedOption = q.options.find(
            (option) => option.correct_answer == true
          );
          answer = selectedOption ? { option_id: selectedOption.id } : null;
          break;
      }
      return answer;
    },
    getAnswerForComprehension(q) {
      let answer = [];
      if (
        q.subtype == this.questionTypes.COMPREHENSION_2Q_SA ||
        q.subtype == this.questionTypes.COMPREHENSION_2Q_MM ||
        q.subtype == this.questionTypes.COMPREHENSION_3Q_SA ||
        q.subtype == this.questionTypes.TC_2Q_SA ||
        q.subtype == this.questionTypes.TC_3Q_SA
      ) {
        q.questions.map((ques, idx) => {
          let selectedOption = ques.options.find(
            (option) => option.correct_answer == true
          );
          if (selectedOption) {
            answer.push({
              question_id: ques.id,
              option_id: selectedOption.id,
            });
          }
        });
      } else {
        q.questions.map((ques, idx) => {
          let options = [];
          ques.options.map((o, idx) => {
            if (o.correct_answer == true) {
              options.push(o.id);
            }
          });

          if (options.length > 0) {
            answer.push({
              question_id: ques.id,
              option_id: options,
            });
          }
        });
      }
      return answer.length > 0 ? answer : null;
    },
    jumpToQuestion(palletData) {
		let searchedQuestion = JSON.parse(localStorage.getItem("searchedQuestion"))
		if(searchedQuestion){
			this.updateSearchAnotherQuestion(
              this.currentQuestion,
              searchedQuestion
            );
		}
		localStorage.removeItem("searchedQuestion");
        localStorage.removeItem("currentQuestion");
      sessionStorage.removeItem("selectedQuestionIds");
      this.showNextQuestion = true;
      this.isUploadAndReplace = false;
      this.isSearchAnotherQ = false;
		this.isCallBucketApi= true;

      this.nextQuestionIndex = palletData.currentQuestionIndex;
      this.endAction = this.QUESTION_ACTIONS.JUMP;
      this.scrollQtypeValue = 2;
      this.saveCurrentAction("currentQuestion");
      // this.expansionPanelStatus = null;
    },
    changeSubjectQuestionType(type, index, action) {
      this.endAction = action ? action : this.endAction;
      this.showNextQuestion = true;
      this.isSQTChanged = true;
      this.isUploadAndReplace = false;
      this.isSearchAnotherQ = false;
      this.setCurrentQuestionData(index, type.currentQuestionIndex);
      this.nextQuestionIndex = type.currentQuestionIndex;
      this.saveCurrentAction("currentQuestion");
      if(this.isApiCall){
        this.getChapters(type.questions[0].datatype.parentDetails.id,type.questions[0].sub_subject);
      }
      this.isApiCall=true;
    },
    reverseQuestionsType() {
      Object.keys(this.questionTypes).forEach((qt) => {
        this.questionTypesReversed[this.questionTypes[qt]] = qt;
      });
    },
    compare(a, b) {
      // Use toUpperCase() to ignore character casing
      const batchA = parseInt(a.index);
      const batchB = parseInt(b.index);

      let comparison = 0;
      if (batchA > batchB) {
        comparison = 1;
      } else if (batchA < batchB) {
        comparison = -1;
      }
      return comparison;
    },
    async separateQuestions() {
      let Paper = []
      let questions = this.questionsListStore;
	  			let mandatoryQuestions = this.testDetails.mandatoryQuestionDetails

      // questions.sort(this.compare);
      let fql = {}; // filteredQuestionsList
      let subjectQuestionTypeList = {}; // for showing subject - section list
      this.$root.showLoader = true;

      for (let i = 0; i < questions.length; i++) {
        let questionTypeId = 0;
        let questionTypeName = "";
        let q = null; // question
        let currentQuestionType = null; // current question in particular subject
        let subjectName = null; // current subject
        let subjectId = null; // current subject
        let subjectQuestionTypeObj = {};
        let questionId = 0;
        let subSubject=null;
        let mandatoryQuestionDetails = {};
        let subTypeName='',subTypeId;
        q = questions[i];
        questionId = q.id;
        
        //Temporary changes to resole question type issue, need to verify it
        questionTypeId = q.questiontype && q.questiontype.id ? q.questiontype.id : (q.question_type ? q.question_type : '');
        questionTypeName = q.questiontype && q.questiontype.value ? q.questiontype.value : (q.question_type_value ? q.question_type_value : '');
        subTypeName = q.subtype && q.subtype.value ? q.subtype.value :'' ;
        subTypeId =q.subtype && q.subtype.id ? q.subtype.id : '';
        subjectName = q.subject.title;
        subSubject=q && q.sub_subject ? q.sub_subject : null;
        subjectId = subSubject ?q.subject.id+subSubject:q.subject.id;
        if (q.sub_subject) {
          let subject = constants.BIOLOGY_SUBSUBJECTS.find(s=>s.code === q.sub_subject)
          if (subject) {
            subjectName = subject.title;
          } 
        }
          
          let i = Paper.findIndex(s=>s.id===subjectId && s.question_type_id === questionTypeId);
            if (i>-1) {
              let j = Paper[i].chapters.findIndex(s=>s.id===q.datatype.id);
            if (j>-1) {
                Paper[i].chapters[j].questions.push({id: q.id,index:q.index,difficulty: q.difficulty_level})
            }else{
              Paper[i].chapters.push({
                id: q.datatype.id,
                questions: [{id: q.id,index:q.index,difficulty: q.difficulty_level}],
                name: q.datatype.title,
              })
            }
          } else {
            let ques = {
              id: subjectId,
              name: subjectName,
              question_type_id: questionTypeId,
              question_type_name: questionTypeName,
              chapters: [{
                id: q.datatype.id,
                questions: [{id: q.id,index:q.index,difficulty: q.difficulty_level}],
                name: q.datatype.title,
  
              }]
            }
            Paper.push(ques)          
          }
        
        
		mandatoryQuestionDetails = mandatoryQuestions && mandatoryQuestions.find(m => m.subject_id === subjectId && m.question_type === questionTypeId),
        subjectQuestionTypeObj = {
          subjectName,
          questionTypeName,
          questionTypeId,
          subTypeId,
          subjectId,
          subTypeName,
          subSubject,
		  mandatoryQuestionDetails
        };

        let subjectQuestionTypeName = subjectName + questionTypeId + subTypeId||'' ;
        if (!subjectQuestionTypeList[subjectQuestionTypeName]) {
          subjectQuestionTypeList[subjectQuestionTypeName] = [];
          subjectQuestionTypeList[subjectQuestionTypeName].push(
            subjectQuestionTypeObj
          );
        }

        if (!fql[subjectName]) fql[subjectName] = {};
        let questionTypeIDName = subTypeId? subTypeId : questionTypeId
        if (!fql[subjectName][questionTypeIDName])
          fql[subjectName][questionTypeIDName] = {}; 
        currentQuestionType = fql[subjectName][questionTypeIDName];
        if (!currentQuestionType["questionIds"])
          currentQuestionType["questionIds"] = []; // list of questions
        currentQuestionType["questionIds"].push(questionId);
      }
      this.setTestData(fql); // in store
      await this.generateQuestionsList();
      this.generateSubjectQuestionList(subjectQuestionTypeList);
      let currentTestCookieExists = this.$cookies.isKey("CATAPULT_TEST");
      let questionIndex = 0;
      let sqtIndex = 0;
      if (currentTestCookieExists) {
        let currentTestDetails = this.$cookies.get("CATAPULT_TEST");
        if (
          currentTestDetails.testId == this.$route.params.test_id &&
          currentTestDetails.testInstituteId ==
            this.$route.params.test_institute_id
        ) {
          this.nextQuestionIndex = currentTestDetails.currentQuestionIndex;
          sqtIndex = currentTestDetails.currentSQTIndex;
        }
        let navigateTo = sqtIndex;
        if (isMobile()) {
          this.navigateTo = navigateTo;
        } else if (
          sqtIndex > 2 &&
          sqtIndex > this.subjectQuestionTypeList.length - 3 &&
          this.subjectQuestionTypeList.length > 2
        ) {
          navigateTo = sqtIndex - 2;
          this.navigateTo = navigateTo;
        }
      }
      this.paperCoverage = Paper
      this.setCurrentQuestionData(sqtIndex, 0);
    },
    setCurrentQuestionData(typeIndex, questionIndex) {
      this.setSelectedSQTIndex(typeIndex);
    },
    async generateQuestionsList() {
      let ql = this.questionsListStore;
      let currentQuestion = {};
      let questionsList = [];
      for (let i = 0; i < ql.length; i++) {
        const q = ql[i]; // current question in loop
        let questionTypeId = q.question_type;
        questionTypeId =
          questionTypeId == this.questionTypes.COMPREHENSION ||
          questionTypeId == this.questionTypes.TC
            ? q.subtype.id ?q.subtype.id :q.subtype
            : q.question_type;
        let currentQuestion = {};
        currentQuestion = this.generateQuestionObject(questionTypeId, q);
        currentQuestion.subtype = q.subtype ? q.subtype.id ?q.subtype.id :q.subtype:'';
        if (
          q.question_type == this.questionTypes.COMPREHENSION ||
          q.question_type == this.questionTypes.TC
        ) {
          currentQuestion.passage = q.passage;
        }
		currentQuestion = this.getCurrentQuestionCommonKeys(currentQuestion, q);
      if (this.isPreview) {

		if(q.questionBucket.length){
			for(let j=0;j<q.questionBucket.length;j++)
				{
						const bq = q.questionBucket[j].question; // current question in loop
				let questionTypeId = bq.question_type;
				questionTypeId =
				questionTypeId == this.questionTypes.COMPREHENSION ||
				questionTypeId == this.questionTypes.TC
					? bq.subtype.id ?bq.subtype.id :bq.subtype
					: bq.question_type;
				let bucketQuestion = {};
				bucketQuestion = this.generateQuestionObject(questionTypeId, bq);
				bucketQuestion.subtype = bq.subtype ? bq.subtype.id ?bq.subtype.id :bq.subtype:'';
				if (
				bq.question_type == this.questionTypes.COMPREHENSION ||
				bq.question_type == this.questionTypes.TC
				) {
				bucketQuestion.passage = bq.passage;
				}
				bucketQuestion = this.getCurrentQuestionCommonKeys(bucketQuestion, bq,j,q.index);
					currentQuestion.questionBucket.push(bucketQuestion);
				}
			}
	  }
				questionsList.push(currentQuestion);
			
		}
        
      this.setFilteredQuestionsList(questionsList);
    },
    getCurrentQuestionCommonKeys(currentQuestion, q,index,bq) {
      currentQuestion.id = q.id;
      currentQuestion.questionNo = q.index? q.index:bq;      
	  currentQuestion.suggestions = index + 1;
      currentQuestion.question_text = q.question_text;
      currentQuestion.question_type = q.question_type;
      currentQuestion.questionType = { id: q.question_type };
      currentQuestion.parent_id = q.parent_id;
      currentQuestion.section_id = q.section_id;
      currentQuestion.test_detail_id = q.test_detail_id;
      currentQuestion.correct_marks = q.marks;
      currentQuestion.negative_marks = q.negative_marks;
      currentQuestion.partial_marking = q.partial_marking;
      currentQuestion.solution = q.solution;
      currentQuestion.hints = q.hints;
      currentQuestion.userSelectedAnswer = q.user_selected_answer;
      currentQuestion.status = this.questionStatus.INITIAL; // "status" along with "isAnswered" will be used for loading legends & pallet info
      currentQuestion.isAnswered = false; // to know if the current question is answered.
      currentQuestion.disabled = false; // disabled in case of preview test
      currentQuestion.isPreview = this.isPreview; // disabled in case of preview 
      currentQuestion.isAttemptingTest = !this.isPreview;
      currentQuestion.institute_id = q.question_institute_id;
      currentQuestion.sub_subject = q.sub_subject;
	  currentQuestion.questionBucket = []
      if (this.isPreview) {

        currentQuestion.status = this.questionStatus.ANSWER_SELECTED_SAVED; // "status" along with "isAnswered" will be used for loading legends & pallet info
        currentQuestion.isAnswered = this.isPreview; // to know if the current question is answered.
        currentQuestion.disabled = this.isPreview; // disabled in case of preview test
      }
      if (this.user && this.user.role_id && this.user.role_id === this.roleIds.TR) {
        const index = this.teacherSubjectId.findIndex(
          (t) => q.subject ?t === q.subject.id :t===q.datatype.parentDetails.id
        );
        currentQuestion.isQuestionEditable = index >= 0;
      } else {
        currentQuestion.isQuestionEditable = true;
      }
      return currentQuestion;
    },
    generateQuestionObject(typeId, q) {
      let type = "";
      type = this.getQuestionType(typeId);
      let currentQuestion = {};
      currentQuestion.chapterId = q.data_type_id;
      currentQuestion.chapterName = q.datatype ? q.datatype.title : "";
      currentQuestion.dataType = q.datatype;
      currentQuestion.datatype = q.datatype;
      currentQuestion.subject_id =
        q.subject_id ||
        (q.subject ? q.subject.id : q.datatype && q.datatype.parentDetails ? q.datatype.parentDetails.id : null);
      currentQuestion.answer_type = q.answer_type;
      currentQuestion.difficulty = q.difficulty;
      if (q.difficulty_level) {
        currentQuestion.difficulty_level = q.difficulty_level || null;
        currentQuestion.difficultyName = this.difficulty.find(
          (d) => d.id === q.difficulty_level
        ).title;
        currentQuestion.difficultyId = this.difficulty.find(
          (d) => d.id === q.difficulty_level
        ).id;
      }
      currentQuestion.question_bucket_count = q.question_bucket_count;
      currentQuestion.time = q.time;
      currentQuestion.topic_id = q.topic_id;
      currentQuestion.topicName = q.topic ? q.topic.title : "";
      currentQuestion.subtopic_id = q.subtopic_id;
      currentQuestion.subtopicName = q.subtopic ? q.subtopic.title : "";
      currentQuestion.subtopic = q.subtopic;
      currentQuestion.concept_id = q.concept_id;
      currentQuestion.conceptName = q.concept ? q.concept.title : "";
      currentQuestion.concept = q.concept;
      currentQuestion.answer_type = q.answer_type;
      currentQuestion.skillsetName = q.answertype ? q.answertype.value : "";
      currentQuestion.answertype = q.answertype;
      currentQuestion.subType = q.subtype;
      currentQuestion.topic = q.topic;
      currentQuestion.sub_subject = q.sub_subject;
      currentQuestion = this.getCurrentQuestionCommonKeys(currentQuestion, q);
      switch (type) {
        case 1:
          currentQuestion.options = this.checkIfAnswered(typeId, q);
          break;
        case 2:
          if (this.isPreview) {
            currentQuestion.correct_answer = q.correct_answer;
          } else if (q.user_selected_answer) {
            let answer = JSON.parse(q.user_selected_answer);
            currentQuestion.correct_answer = parseInt(answer.answer);
          } else {
            currentQuestion.correct_answer = null;
          }
          break;
        case 3:
          let matrixOptions = this.separateOptions(q, 1);
          currentQuestion.options_abc = matrixOptions.options_abc;
          currentQuestion.options_pqr = matrixOptions.options_pqr;
          break;
        case 4:
          let options = this.separateOptions(q, 2);
          currentQuestion.options_abc = options.options_abc;
          currentQuestion.options_pqr = options.options_pqr;
          currentQuestion.options = options.op;
          break;
        case 6:
          if (this.isPreview) {
            currentQuestion.correct_answer = q.correct_answer;
          } else if (q.user_selected_answer) {
            let answer = JSON.parse(q.user_selected_answer);
            currentQuestion.correct_answer = answer.answer;
          } else {
            currentQuestion.correct_answer = "";
          }
          let subjectiveAnswers = this.getSubjectiveAnswers(
            currentQuestion.correct_answer,
            q
          );
          currentQuestion.startValue = subjectiveAnswers.startValue;
          currentQuestion.endValue = subjectiveAnswers.endValue;
          break;
      }
      return currentQuestion;
    },
    checkIfAnswered(type, q) {
      let option = null;
      if (q.user_selected_answer && !this.isPreview) {
        let answer = JSON.parse(q.user_selected_answer);
        q.status = answer.status;
        let options = q.options.map((o) => {
          return { ...o, ...{ correct_answer: false } };
        });
        if (answer.answer) {
          let switchType = 1;
          if (
            this.questionTypes.ASSERTION_REASON == type ||
            this.questionTypes.SINGLE_CORRECT == type ||
			      this.questionTypes.SINGLE_CORRECT_SEC2 == type ||
            this.questionTypes.COMPREHENSION_2Q_SA == type ||
            this.questionTypes.COMPREHENSION_2Q_MM == type ||
            this.questionTypes.COMPREHENSION_3Q_SA == type ||
            this.questionTypes.TC_2Q_SA == type ||
            this.questionTypes.TC_3Q_SA == type
          ) {
            switchType = 1;
          } else {
            switchType = 2;
          }
          switch (switchType) {
            case 1:
              option = options.find((o) => o.id == answer.answer.option_id);
              if (option) option.correct_answer = true;
              break;

            case 2:
              answer.answer.option_id.map((a) => {
                option = options.find((o) => o.id == a);
                if (option) option.correct_answer = true;
              });
              break;
          }
        }
        return options;
      } else return q.options;
    },
    getQuestionType(id) {
      if (
        id == this.questionTypes.ASSERTION_REASON ||
        id == this.questionTypes.MULTIPLE_CORRECT ||
        id == this.questionTypes.SINGLE_CORRECT ||
		    id == this.questionTypes.SINGLE_CORRECT_SEC2 ||
        id == this.questionTypes.COMPREHENSION_2Q_SA ||
        id == this.questionTypes.COMPREHENSION_2Q_MA ||
        id == this.questionTypes.COMPREHENSION_3Q_SA ||
        id == this.questionTypes.COMPREHENSION_3Q_MA ||
        id == this.questionTypes.TC_2Q_SA ||
        id == this.questionTypes.COMPREHENSION_2Q_MM ||
        id == this.questionTypes.TC_3Q_SA
      ) {
        return 1;
      } else if (id == this.questionTypes.INTEGER) {
        return 2;
      } else if (id == this.questionTypes.MATRIX_MATCH) {
        return 3;
      } else if (id == this.questionTypes.MATRIX_MATCH_OPTION) {
        return 4;
      } else if (id == this.questionTypes.COMPREHENSION) {
        return 5;
      } else if (id == this.questionTypes.SUBJECTIVE || id == this.questionTypes.COMPREHENSION_2Q_NU || id == this.questionTypes.SUBJECTIVEINTEGER) {
        return 6;
      }
    },
    getSubjectiveAnswers(answer, q) {
      let separatedAnswer = {
        startValue: null,
        endValue: null,
      };
      if (answer > "" && this.isPreview) {
        let answerArray = answer.split("##");
        if (answerArray.length == 2) {
          separatedAnswer.startValue = answerArray[0];
          separatedAnswer.endValue = answerArray[1];
        } else if (answerArray.length == 1) {
          separatedAnswer.startValue = answerArray[0];
        }
      } else if (q.user_selected_answer) {
        let answer = JSON.parse(q.user_selected_answer);
        if (
          answer.answer &&
          !answer.answer.startValue &&
          !answer.answer.endValue
        ) {
          separatedAnswer.correct_answer = parseInt(answer.answer);
        }
      }
      return separatedAnswer;
    },
    checkIfAnswered(type, q) {
      let option = null;
      if (q.user_selected_answer && !this.isPreview) {
        let answer = JSON.parse(q.user_selected_answer);
        q.status = answer.status;
        let options = q.options.map((o) => {
          return { ...o, ...{ correct_answer: false } };
        });
        if (answer.answer) {
          let switchType = 1;
          if (
            this.questionTypes.ASSERTION_REASON == type ||
            this.questionTypes.SINGLE_CORRECT == type ||
			      this.questionTypes.SINGLE_CORRECT_SEC2 == type ||
            this.questionTypes.COMPREHENSION_2Q_SA == type ||
            this.questionTypes.COMPREHENSION_2Q_MM == type ||
            this.questionTypes.COMPREHENSION_3Q_SA == type ||
            this.questionTypes.TC_2Q_SA == type ||
            this.questionTypes.TC_3Q_SA == type
          ) {
            switchType = 1;
          } else {
            switchType = 2;
          }
          switch (switchType) {
            case 1:
              option = options.find((o) => o.id == answer.answer.option_id);
              if (option) option.correct_answer = true;
              break;

            case 2:
              answer.answer.option_id.map((a) => {
                option = options.find((o) => o.id == a);
                if (option) option.correct_answer = true;
              });
              break;
          }
        }
        return options;
      } else return q.options;
    },
    generateSubjectQuestionList(subjectQuestionTypeList) {
      let sqtl = []; // subjectQuestionTypeList
      let subjectQuestionTypeObj = {};
      let name = "";
      let shortName = "";
      let typeId = "";
      let subTypeId = "";
      let subjectId = "";
      let subjectName = "";
      let questionIds = [];
      let typeList = [];
      let questions = [];
      let questionObj = {};
	  let mandatoryQuestions={};
      let subjectNames = Object.keys(subjectQuestionTypeList);
      subjectNames.forEach((subject) => {
        typeList = subjectQuestionTypeList[subject];
        questions = [];
        typeList.forEach((type) => {
          questionObj = {};
          name = type.subjectName + " - " +  (type.subTypeName?type.subTypeName:type.questionTypeName);
          shortName =  type.subjectName
            ?  (((Number(this.testDetails.target) === constants.TARGET_EXAMS.KCET || 
                  Number(this.testDetails.target) === constants.TARGET_EXAMS.BITSAT || 
                  Number(this.testDetails.target) === constants.TARGET_EXAMS.VITEEE || 
                  Number(this.testDetails.target) === constants.TARGET_EXAMS.SRMJEE || 
                  Number(this.testDetails.target) === constants.TARGET_EXAMS.MHCET || this.user.institute == constants.ONLINE_INSTITUTE_ID) &&
                  (type.subjectName == 'Botany' || type.subjectName == 'Zoology'))  ? 'Biology' : type.subjectName.substr(0, 4)) +
              " - " +
              (type.subTypeName ? type.subTypeName : type.questionTypeName)
            : null;
          typeId = type.questionTypeId;
          subTypeId = type.subTypeId;
          subjectId = type.subjectId;
          subjectName = type.subjectName;
			mandatoryQuestions = type.mandatoryQuestionDetails;
          let typeIdName = subTypeId ? subTypeId: typeId;
          questionIds = this.testData[type.subjectName][typeIdName].questionIds;
          // questionIds.sort();
          questionIds.forEach((qi, idx) => {
			  questionObj = {}
            questionObj = this.filteredQuestionsList.find(q=>q.id===qi);
            questionObj.currentQuestionIndex = idx + 1;
            questions.push(questionObj);
          });
          subjectQuestionTypeObj = {
            name,
            shortName,
            typeId,
            subjectId,
            questionIds,
            subjectName,
            questions,
            showSQT: this.teacherSubjectId.length
              ? this.AssignedTeacher.findIndex(a=>a.subject_id===subjectId && a.assigned_to===this.user.id && this.teacherSubjectId.includes(subjectId)) >-1
              : true,
            currentQuestionIndex: 0,
			mandatoryQuestions,
            showAnswerField: true, // will be changed to true when loading into question paper modal
			
          };
			if (subjectQuestionTypeObj.showSQT) {
	          sqtl.push(subjectQuestionTypeObj);
			}
        });
      });
      if (sqtl && sqtl.length > 0) {
        // this.getChapters(sqtl[0].subjectId);
      }

       if (
  this.testDetails &&
  (Number(this.testDetails.target) === constants.TARGET_EXAMS.KCET ||
   Number(this.testDetails.target) === constants.TARGET_EXAMS.BITSAT ||
   Number(this.testDetails.target) === constants.TARGET_EXAMS.VITEEE ||
   Number(this.testDetails.target) === constants.TARGET_EXAMS.SRMJEE ||
   Number(this.testDetails.target) === constants.TARGET_EXAMS.MHCET || this.user.institute == constants.ONLINE_INSTITUTE_ID)
) {
  const biology = {};
  const biologyOrder = [];
  const others = [];

  sqtl.forEach((item) => {
    if ( item.subjectName === 'Botany' ||
      item.subjectName === 'Zoology' ||
      item.subjectName === 'Biology') {
      if (!biology[item.typeId]) {
        biology[item.typeId] = {
          ...item,
          subjectName: 'Biology',
          name: item.name.replace(item.subjectName, 'Biology'),
          shortName: item.shortName.replace(item.subjectName, 'Biology'),
          questions: [],
          questionIds: [],
          subjectId: 'biology',
        };
        biologyOrder.push(item.typeId); 
      }
      biology[item.typeId].questions = biology[item.typeId].questions.concat(item.questions);
      biology[item.typeId].questionIds = biology[item.typeId].questionIds.concat(item.questionIds);
    } else {
      others.push(item);
    }
  });

biologyOrder.forEach(typeId => {
  if (biology[typeId] && biology[typeId].questions && biology[typeId].questions.length > 0) {
    biology[typeId].questions.sort((a, b) => {
      return Number(a.questionNo || 99999) - Number(b.questionNo || 99999);
    });
  }
});
  sqtl = sqtl.reduce((acc, item) => {
    if (
      item.subjectName === "Botany" ||
      item.subjectName === "Zoology" ||
      item.subjectName === "Biology"
    ) {
      if (biology[item.typeId]) {
        acc.push(biology[item.typeId]);
        delete biology[item.typeId]; 
      }
    } else {
      acc.push(item);
    }
    return acc;
  }, []);
}
      this.setSubjectQuestionTypeList(sqtl);
      this.$root.showLoader = false;
      // this.subjectQuestionTypeList = sqtl;
    },
    onClose(data) {
      this.status = data.status;
	  if(data.callApi)
		{
			this.requestGetTestDetails()
		}  
      if (data.count) {
		     
		this.currentQuestion.question_bucket_count = data.count;
      } else if (data.count === 0) {
        this.currentQuestion.question_bucket_count = 0;
      }
	  this.isCallBucketApi = false
      //   if(data.reload){
      // 	  this.requestGetTestDetails();
      //   }
    },
    logOutUser() {
      this.$toasted.error(
        "You have a slow internet connection. Please check and try again."
      );
      this.logOut().then(()=>{
        this.$router.push({ name: "login" });
        this.$cookies.remove('userToken',this.COOKIE_PATH,this.COOKIE_DOMAIN);
        this.$cookies.remove('isShowErrorMsg',this.COOKIE_PATH,this.COOKIE_DOMAIN);
        this.$cookies.remove('keepMeLoggedIn',this.COOKIE_PATH,this.COOKIE_DOMAIN);
        this.$cookies.remove('upgrade',this.COOKIE_PATH,this.COOKIE_DOMAIN);
        this.$cookies.remove('isLoggedIn',this.COOKIE_PATH,this.COOKIE_DOMAIN);

      });
    },
    waitForResponse() {
      let remainingSeconds = 60;
      this.$root.showLoader = true;
      this.responseTimeOut = setInterval(() => {
        this.$root.showLoader = true;
        if (remainingSeconds <= 0 && !this.testDetails) {
          clearInterval(this.responseTimeOut);
          this.$root.showLoader = false;
          this.setIsTestStarted(false);
          this.logOutUser();
        }
        if (this.testDetails && this.testDetails.questions) {
          clearInterval(this.responseTimeOut);
          this.$root.showLoader = false;
        }
        remainingSeconds--;
      }, 1000);
    },
    requestGetTestDetails() {
      let pendingTestList = this.pendingTestList;
      if (parseInt(this.$route.params.test_id) &&  parseInt(this.$route.params.test_institute_id)) {
        
        let reqData = {
          test_id: this.$route.params.test_id,
          test_institute_id: this.$route.params.test_institute_id,
          is_preview: this.isPreview,
        };
        this.$root.showLoader = true;
        let fn = "getMYTPreviewDetails";
        this[fn](reqData)
          .then((response) => {
            if (response) {
              
              this.$root.showLoader = false;
              this.testDetails = response;
              this.duration = this.testDetails.timeRemaining;
              this.isOnlineTest = localStorage.getItem("isOnlineTest", this.tab)==='Online'
              if (
                this.testDetails.test_type != this.TEST_TYPE.CUSTOM &&
                (this.$route.name == "preview-test" ||
                  this.$route.name == "result-anaylysis-preview-test")
              ) {
                this.isTestCustom = false;
              }
              this.isDBTest= this.testDetails.is_db_test === 1
              this.isEditable = this.testDetails.test_is_conducted_or_running === 1;
              this.instructions = response.instructions;
              this.isEditableTest = response.is_editable === 1 ? true : false;
              this.separateQuestions();
              this.renderMath();
              // this.getQuestionData();
            }else {
              this.$toasted.error(`Sorry!!!, We are unable to fetch test information. Please check\n1.  You are connected to internet\n2.  Your browser is up to date\n3.  Please check your firewall settings.\nStill error persist please contact admin with screenshot.`, { icon: 'info', className: 'custom-toast' })
            }
          })
          .catch((err) => {
            this.$root.showLoader = false;
  
            if (pendingTestList) {
              pendingTestList.shift();
              this.setPendingTestList(pendingTestList);
            }
            this.setIsTestStarted(false);
            this.$toasted.error(`Sorry!!!, We are unable to fetch test information. Please check\n1.  You are connected to internet\n2.  Your browser is up to date\n3.  Please check your firewall settings.\nStill error persist please contact admin with screenshot.`, { icon: 'info', className: 'custom-toast' })
            // this.redirectAsType();
            this.$router.push({ name: "schedule-tests" });
          });
      }
    },
    separateOptions(q, type) {
      let options = q.options;
      let op = [];
      let options_abc = [];
      let options_pqr = [];

      options.forEach((option) => {
        if (option.column == 1) {
          option.correct_answer = option.correct_answer
            ? option.correct_answer
            : "";
          options_abc.push(option);
        } else if (option.column == 2) options_pqr.push(option);
        else {
          option.correct_answer = option.correct_answer
            ? option.correct_answer
            : false;
          // option.correct_answer = false;
          op.push(option);
        }
      });
      if (type == 1) {
        if (q.user_selected_answer) {
          let answer = JSON.parse(q.user_selected_answer);
          if (answer.answer) {
            answer.answer.map((a) => {
              let option = options_abc.find((o) => o.id == a.option_id);
              if (option) {
                option.correct_answer = a.value;
              }
            });
          }
        }
      } else {
        if (q.user_selected_answer) {
          let answer = JSON.parse(q.user_selected_answer);
          if (answer.answer) {
            let option = op.find((o) => o.id == answer.answer.option_id);
            if (option) {
              option.correct_answer = true;
            }
          }
        }
      }

      return {
        op,
        options_abc,
        options_pqr,
      };
    },

    handleKeyboardEvents() {
      document.addEventListener("contextmenu", function(e) {
        e.preventDefault();
      });
      document.onkeydown = function(e) {
        if (event.keyCode == 123) {
          return false;
        }
        if (e.ctrlKey && e.keyCode == "R".charCodeAt(0)) {
          return false;
        }
        if (e.ctrlKey && e.shiftKey && e.keyCode == "R".charCodeAt(0)) {
          return false;
        }
        if (e.ctrlKey && e.shiftKey && e.keyCode == "I".charCodeAt(0)) {
          return false;
        }
        if (e.ctrlKey && e.shiftKey && e.keyCode == "C".charCodeAt(0)) {
          return false;
        }
        if (e.ctrlKey && e.shiftKey && e.keyCode == "J".charCodeAt(0)) {
          return false;
        }
        if (e.ctrlKey && e.keyCode == "U".charCodeAt(0)) {
          return false;
        }
      };
      // switch (event.keyCode) {
      //     case 116: // 'F5'
      //         event.preventDefault();
      //         event.returnValue = false;
      //         break;
      //     case 82: // 'F5'
      //         event.preventDefault();
      //         event.returnValue = false;
      //         event.keyCode = 0;
      //         window.status = "We have disabled F5";
      //         break;
      // }
    },
    replaceToOriginal() {
      if (this.isSearchAnotherQ) {
        const question = JSON.parse(localStorage.getItem("searchedQuestion"));
        // this.currentQuestion = question
        this.updateSearchAnotherQuestion(this.currentQuestion, question);
        this.currentQuestion.last_created_at = question.last_created_at;
        this.isSearchAnotherQ = false;
        localStorage.removeItem("searchedQuestion");
        localStorage.removeItem("currentQuestion");

      }
      if (this.isUploadAndReplace) {
        const question = JSON.parse(localStorage.getItem("currentQuestion"));
        // this.currentQuestion = question

        this.updateSearchAnotherQuestion(this.currentQuestion, question);
        this.currentQuestion.last_created_at = question.last_created_at;
        this.isUploadAndReplace = false;
        localStorage.removeItem("searchedQuestion");
        localStorage.removeItem("currentQuestion");
      }
	  sessionStorage.removeItem('selectedQuestionIds')
      this.isEditing = false;
    },
    searchAnotherQ() {
      if (!this.isSearchAnotherQ) {
        this.slectedChapter = {
          chapter_id: this.currentQuestion.chapterId,
          title: this.currentQuestion.chapterName,
        };
      
        this.getTopics(this.slectedChapter.chapter_id);
      }
      this.isUploadAndReplace = false;
      if (!this.isSearchAnotherQ) {
        this.selectedTopic = {
          topic_id: this.currentQuestion.topic_id,
          title: this.currentQuestion.topicName,
        };

      }
      if (!this.isSearchAnotherQ) {
        this.selectedDifficultyLevel = {
          id: this.currentQuestion.difficultyId,
          title: this.currentQuestion.difficultyName,
        };
      }
       
      this.$forceUpdate();
		this.$root.showLoader = true

      this.isSearchAnotherQ = true;
	  let isSet = JSON.parse(localStorage.getItem("searchedQuestion"))
	  if (!isSet) {
		      localStorage.setItem(
        "searchedQuestion",
        JSON.stringify(this.currentQuestion)
      );  
	  }

      const test = JSON.parse(localStorage.getItem("test"));
      let selectedQuestionIds = [];
      selectedQuestionIds = JSON.parse(
        sessionStorage.getItem("selectedQuestionIds")
      );
      if (!selectedQuestionIds) {
        selectedQuestionIds = [];
        selectedQuestionIds.push(this.currentQuestion.id);
        sessionStorage.setItem(
          "selectedQuestionIds",
          JSON.stringify(selectedQuestionIds)
        );
      }
      const reqData = {
        test_detail_id: this.currentQuestion.test_detail_id,
        subject_id: this.currentQuestion.dataType.parent,
        required_questions: 1,
        question_type: this.currentQuestion.question_type,
        target_exam: this.testDetails.target,
        difficulty_level: this.selectedDifficultyLevel
          ? this.selectedDifficultyLevel.id
          : 1,
        
        chapter_ids: this.slectedChapter.chapter_id
          ? [this.slectedChapter.chapter_id]
          : [],
        topic_ids: this.selectedTopic.topic_id
          ? [this.selectedTopic.topic_id]
          : [],


        test_id: this.testDetails.id,
        required_question_details: true,
        selectedQuestionIds: selectedQuestionIds,
        required_single_child_question_details :this.currentQuestion.question_type === this.questionTypes.COMPREHENSION ||this.currentQuestion.question_type === this.questionTypes.TC,
        institute_id:this.myInstitute.id,
        creator_id: this.user ? this.user.id.toString(): localStorage.getItem('guest_user_id')
      };
      if (this.slectedChapter.chapter_id) {
        reqData.chapter_ids = [this.slectedChapter.chapter_id];
      }
      if (this.selectedTopic.topic_id) {
        reqData.topic_ids = [this.selectedTopic.topic_id];
      }
    
      if (this.selectedDifficultyLevel.id) {
        reqData.difficulty_level = this.selectedDifficultyLevel.id;
      }

      if (this.currentQuestion.subtype) {
        reqData.subType = this.currentQuestion.subtype;
      }
      this.searchAnotherMytQuestion(reqData)
        .then((response) => {
		this.$root.showLoader = false

          if (response.list && response.list.length) {
                      if (
              this.currentQuestion.question_type === this.questionTypes.COMPREHENSION ||
              this.currentQuestion.question_type === this.questionTypes.TC
            ) {
              selectedQuestionIds.push(response.list[0].parent_id);
              // this.requestGetTestDetails();
            }else{
              selectedQuestionIds.push(response.list[0].id);
            }
            sessionStorage.setItem(
              "selectedQuestionIds",
              JSON.stringify(selectedQuestionIds)
            );
            this.setDisableSecondaryAction(false);
            this.updateSearchAnotherQuestion(
              this.currentQuestion,
              response.list[0]
            );
			if (this.selectedDifficultyLevel.id===response.list[0].difficulty_level) {
				this.$toasted.success(`${response.message}`, {
					icon: "check_circle",
				});
			}else {
				this.$toasted.success(`Couldn't find the exact match of the difficulty level, hence, suggesting the most suitbale question available`, {
					icon: "check_circle",
				});
				this.selectedDifficultyLevel = {
					id: response.list[0].difficulty_level,
					title: this.difficulty.find((d) => d.id === response.list[0].difficulty_level).title ||""
				}
			}
            
          } else {
            this.$toasted.error("Question not found with selected priorities");
            // this.isSearchAnotherQ = false;
          }
        })
        .catch((err) => {
		this.$root.showLoader = false
        });
    },
    replaceSearchAnotherQuestion() {
      const reqData = {
        test_detail_id: this.currentQuestion.test_detail_id,
        question_id: this.currentQuestion.id,
        question_type:this.currentQuestion.question_type,
        target_exam:this.testDetails.target,
        institute_id:this.myInstitute.id
      };
          if (
              this.currentQuestion.question_type === this.questionTypes.COMPREHENSION ||
              this.currentQuestion.question_type === this.questionTypes.TC
            ) {
              reqData.question_id= this.currentQuestion.parent_id;
              // this.requestGetTestDetails();
            }
      this.replaceQuestion(reqData)
        .then((response) => {
          // if (
          //     this.currentQuestion.question_type === this.questionTypes.COMPREHENSION ||
          //     this.currentQuestion.question_type === this.questionTypes.TC
          //   ) {
              this.requestGetTestDetails();
            // }
            // else{

            //   this.updateSearchAnotherQuestion(
            //     this.currentQuestion,
            //     response.details
            //   );
            // }
          this.setDisableSecondaryAction(false);
          this.$toasted.success(`${response.message}`, {
            icon: "check_circle",
          });
		  localStorage.removeItem("searchedQuestion");
        localStorage.removeItem("currentQuestion");
          sessionStorage.removeItem("selectedQuestionIds");
          this.isSearchAnotherQ = false;
        })
        .catch((err) => {
          this.$toasted.error("Error Replacing Question");
          // this.isSearchAnotherQ = false
        });
    },
    getAnswerType(questionType, subtype) {
      let answerType = 0;

      if (
        questionType == this.QUE_TYPES.COMPREHENSION ||
        questionType == this.QUE_TYPES.TC
      ) {
        answerType = 0; // for questions with subtypes
        if (
          subtype == this.QUE_TYPES.TC_2Q_SA ||
          subtype == this.QUE_TYPES.COMPREHENSION_2Q_SA ||
          subtype == this.QUE_TYPES.COMPREHENSION_2Q_MA ||
          subtype == this.QUE_TYPES.COMPREHENSION_2Q_MM ||
          subtype == this.QUE_TYPES.COMPREHENSION_2Q_NU
        ) {
          this.subQuestionLength = 2;
        } else if (
          subtype == this.QUE_TYPES.COMPREHENSION_3Q_MA ||
          subtype == this.QUE_TYPES.COMPREHENSION_3Q_SA ||
          subtype == this.QUE_TYPES.TC_3Q_SA
        ) {
          this.subQuestionLength = 3;
        }
      } else if (
        questionType == this.QUE_TYPES.ASSERTION_REASON ||
        questionType == this.QUE_TYPES.MULTIPLE_CORRECT ||
        questionType == this.QUE_TYPES.SINGLE_CORRECT
      ) {
        answerType = 1; // for questions options
      } else if (
        questionType == this.QUE_TYPES.MATRIX_MATCH_OPTION ||
        questionType == this.QUE_TYPES.MATRIX_MATCH
      ) {
        answerType = 2; // for questions with options, optionsabc, optionspqr
      } else if (questionType == this.QUE_TYPES.SUBJECTIVE || questionType == this.QUE_TYPES.SUBJECTIVEINTEGER) {
        answerType = 3; // for subjective type questions
      } else if (questionType == this.QUE_TYPES.INTEGER) {
        answerType = 4; // for integer type questions
      }
      return answerType;
    },
    setDummyAnswerAsPerType(currentQuestion) {
      this.subQuestionLength = 0;
      let answerType = 0;
      let questionType = currentQuestion.questionType.id;
      // check if type is comprehension or tc and set the sub questions length
      answerType = this.getAnswerType(questionType, currentQuestion.subtype);

      let options = null;
      let optionsABC = null;
      let optionsPQR = null;

      switch (answerType) {
        case 0:
          currentQuestion.questions = [];
          for (let i = 0; i < this.subQuestionLength; i++) {
            if (currentQuestion.subtype != this.QUE_TYPES.COMPREHENSION_2Q_NU) {
              
              currentQuestion.questions.push({
                question_text: this.DUMMYTEXT,
                options: _.cloneDeep(this.dummyOptions),
              });
            }else{
              currentQuestion.questions.push({
                question_text: this.DUMMYTEXT,
                correct_answer: "0##0"
              });
            }
          }
        case 1:
          // options = _.cloneDeep(this.dummyOptions);
          currentQuestion.options = _.cloneDeep(this.dummyOptions);
          currentQuestion.correct_answer = "0";
          break;

        case 2:
          currentQuestion.options =
            questionType == this.QUE_TYPES.MATRIX_MATCH_OPTION
              ? _.cloneDeep(this.dummyOptions)
              : [];
          currentQuestion.options_abc = _.cloneDeep(this.dummyOptionsABC);
          currentQuestion.options_pqr = _.cloneDeep(this.dummyOptionsPQR);
          break;

        case 3:
          // currentQuestion.startValue = "0";
          // currentQuestion.endValue = "0";
          currentQuestion.correct_answer = "0##0";
          break;

        case 4:
          currentQuestion.correct_answer = "0";
          break;

        default:
          break;
      }
      return currentQuestion;
    },
    validate() {
      let isValid = true;
      if (!this.slectedChapter.chapter_id) {
        this.$toasted.error("Please Select Chapter");
        isValid = false;
      }
      if (!this.selectedTopic.topic_id && this.isDBTest) {
        this.$toasted.error("Please Select Topic");
        isValid = false;
      }
      if (!this.selectedDifficultyLevel.id && this.isDBTest) {
        this.$toasted.error("Please Select Difficulty Level");
        isValid = false;
      }
       if (!this.selectedSkillSet.id && this.isDBTest) {
        this.$toasted.error("Please Select skill set");
        isValid = false;
      } //Validity check!
      if (!this.selectedSubTopic.subtopic_id && this.isDBTest) {
        this.$toasted.error("Please Select SubTopic");
        isValid = false;
      }
      if (!this.selectedConcept.concept_id && this.isDBTest) {
      this.$toasted.error("Please Select Concept");
      isValid = false;
    }

      return isValid;
    },
    similarQuestionsPopup() {
      this.alertBoxData = {
        question: {
          ...this.currentQuestion,
          target_exam: this.testDetails.target,
          test_id: this.testDetails.id,
        },
        errorDescription: "",
        isPreview: this.isPreview,
        isEditable: this.isEditable,
		isCallBucketApi: this.isCallBucketApi
      };
      this.modalWidth = "1000px";
      this.status = true;
      this.cComponent =
        "components/coordinator/Tests/CustomizedTests/SimilarQuestions";
      this.$forceUpdate();
    },
    getTeacherSubjectTree() {
      this.getTeacherSubject()
        .then((response) => {
          this.teacherSubjectId = response;
        })
        .catch((err) => {
        });
    },
	   
      getSubTopics(subTopicId) {
       if ((subTopicId || this.selectedTopic.topic_id) && this.isPreview) {
         let reqData = {
          level: 5,
          parent: subTopicId || this.selectedTopic.topic_id
        } 
        this.subTopics = [];
        this.concepts = [];
        this.getDataTreeWithLevel(reqData)
          .then((response) => {
            let subTopicList = [];
            response.map((x) => {
              let c = {};
              c.text = x.title;
              c.value = { subtopic_id: x.id, title: x.title };
              subTopicList.push(c);
            });
            this.$forceUpdate();
            this.subTopics = subTopicList;
          })
          .catch((err) => {
          });
       };
    },
    getConcepts(conceptId) {
      this.concepts = []
       if ((conceptId || this.selectedSubTopic.subtopic_id) && this.isPreview) {
         let reqData = {
          level: 6,
          parent: conceptId || this.selectedSubTopic.subtopic_id
        } 
        this.concepts = [];
        this.getDataTreeWithLevel(reqData)
          .then((response) => {
             this.concepts = response.map((x) => {
              let c = {};
              c.text = x.title;
              c.value = { concept_id: x.id, title: x.title };
              return c;
            });
          })
          .catch((err) => {
          });
       }
      
    },
    getSkillSets(skillsetId) {
        this.skillset = [];
         let reqData = {
         keys: ["ANSWER_TYPE"]
        } 
        this.getRefData(reqData)
          .then((response) => {
            // this.$root.showLoader = false;
             this.skillset = response.ANSWER_TYPE.map((x) => {
              let c = {};
              c.text = x.value;
              c.value = { id: x.id, title: x.value };
              return c;
            });
          })
          .catch((err) => {
            // this.$root.showLoader = false;
          });
      
    },
     onSelectedSubTopic(e) {
      sessionStorage.removeItem("selectedQuestionIds");

      if (this.currentQuestionToBeEdited) {
        this.currentQuestionToBeEdited.subtopic_id = e.subtopic_id;
        this.currentQuestionToBeEdited.subtopicName = e.title;
      }
      if (this.currentQuestion) {
      
        this.currentQuestion.subtopic_id = e.subtopic_id;
        this.currentQuestion.subtopicName = e.title;
      }
      this.getConcepts(e.subtopic_id);
     
    },
    onSelectedConcept(e) {
    sessionStorage.removeItem("selectedQuestionIds");

    if (this.currentQuestionToBeEdited) {
      this.currentQuestionToBeEdited.concept_id = e.concept_id;
      this.currentQuestionToBeEdited.conceptName = e.title;
    }
    if (this.currentQuestion) {
    
      this.currentQuestion.concept_id = e.concept_id;
      this.currentQuestion.conceptName = e.title;
    }
     
  },
    onselectedSkillset(e) {
      sessionStorage.removeItem("selectedQuestionIds");
      if (this.currentQuestionToBeEdited) {
        this.currentQuestionToBeEdited.answer_type = e.id;
        this.currentQuestionToBeEdited.skillsetName = e.value;
      }
      if (this.currentQuestion) {
        this.currentQuestion.answer_type = e.id;
        this.currentQuestion.skillsetName = e.value;
      }
    },
    getQuestionInfo(){
      this.currentQuestion.show_extra_details = false;
      let reqData = {
        question_id: this.currentQuestion.id,
        user_id: this.user ? this.user.id.toString(): localStorage.getItem('guest_user_id'),
        test_id: this.testDetails.id

      }
      this.getQuestionUsageDetails(reqData).then(response=>{
        if (response) {
          this.currentQuestion.history_details = response.map(s=>{
            s.created_at=moment(s.created_at).format(constants.DATE_FORMATS.DISPLAY_DATE);
            return s;
          });
          if (response.length) {
            this.currentQuestion.last_created_at = response[0].created_at
          }
        }

      }).catch(err=>{
        console.log(err);
      })
    },
    openHistoryDialog() {
      this.alertBoxData = {
        question: this.currentQuestion,
      };
      this.modalWidth = "600px";
      this.status = true;
      this.cComponent = "components/CustomInstituteComponents/HistoryDetails/HistoryDetails";
      this.$forceUpdate();
    },
    openMandatoryQuePopup(){
      this.alertBoxData = {
        mandatoryQueCount: this.questionData.mandatoryQuestions,
        allQuestionCount: this.questionData.questions.length
      };
      this.alertBoxData.persistent = true;
      this.modalWidth = "420px";
      this.status = true;
      this.cComponent = "components/student/Tests/PastTests/MandatoryQuePopup";
      this.setDisableSecondaryAction(false);
      this.$forceUpdate();
    },
    
   
    openMandatoryQuePopup(){
      this.alertBoxData = {
        mandatoryQueCount: this.questionData.mandatoryQuestions,
        allQuestionCount: this.questionData.questions.length
      };
      this.alertBoxData.persistent = true;
      this.modalWidth = "420px";
      this.status = true;
      this.cComponent = "components/student/Tests/PastTests/MandatoryQuePopup";
      this.setDisableSecondaryAction(false);
      this.$forceUpdate();
    },
    
    goToQuestion(question, currentQuestionIndex, subject) {
      if (question) {
        let index = this.subjectQuestionTypeList.findIndex(s => s.subjectId === subject.id && s.typeId === subject.question_type_id);
        let qIndex = this.subjectQuestionTypeList[index].questions.findIndex(q => q.id === question.id)
        this.showNextQuestion = true;
        this.isUploadAndReplace = false;
        this.isSearchAnotherQ = false;
        this.isCallBucketApi = true;
        this.isSQTChanged = true;
        this.status = false

        this.nextQuestionIndex = qIndex;
        this.setCurrentQuestionData(index, qIndex);

        this.endAction = this.QUESTION_ACTIONS.JUMP;
        this.scrollQtypeValue = 2;
        this.saveCurrentAction("currentQuestion");
      }
    },
    onPaperCoverage(){
      this.alertBoxData = {subjects:this.paperCoverage, "isPastTest":this.isPastTest,"isCustom":this.isTestCustom,"isPreview":this.isPreview,goToQuestion: this.goToQuestion};
      this.modalWidth = "1000px";
      this.status = true;
      this.cComponent = "components/PreviewTest/PaperCoverage";
      this.$forceUpdate();
    },
  },
 
};
</script>
